import React, { useState, useEffect, useRef, useMemo } from "react";
import { Row, Button, Col, Tag, Checkbox, Card, Input, Space, Divider, Typography, Modal, Radio, Select, Drawer, Switch, Badge, Skeleton, Tooltip, message } from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  CloseOutlined,
  TeamOutlined,
  LoadingOutlined,
  StopOutlined,
  SearchOutlined,
  PlusOutlined,
  MinusOutlined,
  CloseSquareFilled,
  CarOutlined,
  ReloadOutlined,
  GiftOutlined,
  CompassFilled,
  StarOutlined,
  LockOutlined,
  UnlockOutlined,
  SendOutlined,
  CopyOutlined,
  EditOutlined,
  DownOutlined,
  UpOutlined,
  CodeSandboxOutlined,
  PlayCircleOutlined,
  DeleteOutlined,
  ClockCircleOutlined,
  FireOutlined,
  PauseOutlined,
  ShopOutlined,
  ThunderboltOutlined,
  MessageOutlined,
  RadarChartOutlined,
} from "@ant-design/icons";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import defaultImage from "../../../assets/images/no-image.svg";
import Back from "../../../assets/images/backIcon.svg";
import data from "../../../constants/restaurantPos.json";
import removeBg from "../../../assets/images/removebg.png";
import PlusIcon from "../../../assets/images/plusIconRestaurant.svg";
import minusIcon from "../../../assets/images/minusIconRestaurant.svg";
import DeleteProduct from "../../../assets/images/delete1.svg";
import addNote from "../../../assets/images/addNote.svg";
import DecrementImg from "../../../assets/images/Decrement2.svg";
import IncrementImg from "../../../assets/images/Increment2.svg";
import userIcon from "../../../assets/images/userId.svg";
import Close from "../../../assets/images/close-x.svg";
import DiscountIcon from "../../../assets/images/discountperIcon.svg";
import printBill from "../../../assets/images/printbillIcon.svg";
import Offers from "../../../assets/images/promoTag.svg";
import MoreOptionsIcon from "../../../assets/images/moreOptionsIcon.svg";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import OrderListComponent from "./OrderListComponent";
import messages from "../../../errors/messages.en-IN.json";
import { v4 as uuidv4 } from "uuid";
import "./restaurantStyle.css";
import moment from "moment";
import db from "../../../database";
import _, { set } from "lodash";
import Keyboard from "react-simple-keyboard";
import TextArea from "antd/lib/input/TextArea";
import PointOfSaleRetailModals from "../Retail/RetailModals";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../../utility/getMultilingualText ";
import { useEventBus } from "../../../lib/hooks/EventBusProvider";
import PrintController from "../../../lib/printer/printController";
import { numberToWords } from "../../../utility/numberToWords";
import FilterIcon from "../../../assets/images/filterNewICon.svg";
import vegIcon from "../../../assets/images/veg.png";
import eggIcon from "../../../assets/images/egg.png";
import { getWorkflowData } from "../../../utility/getWorkflowData";
import TableFeatures from "./Tables-Management/TableFeatures";
import ReprintKotDialog from "./ReprintKotDialog";
import { SyncData } from "./Tables-Management/SyncData";
import CWKOTPrinter from "../../../lib/printer/CWKotPrinter";
import { kotPrinter } from "../../../lib/printer/kotPrinter";
import { cancelKOTPrinter } from "../../../lib/printer/cancelKOTPrinter";
import { productPriceOnScan } from "../../../services/generic";
const { Option } = Select;

const MenuLayout = (props) => {
  const {
    paymentModalInputRef,
    tillAccessData,
    setSelectedProductInCart,
    selectedProductId,
    setSelectedProductId,
    manualDiscountRestaurant,
    selectedSaleType,
    setSelectedSaleType,
    cart,
    restaurantProductCategory,
    productsData,
    pickProduct,
    decreaseProductQty,
    deleteProduct,
    increaseProductQty,
    handleOrder,
    handleVoid,
    addDefinedProductWithAddons,
    addProductWithAddons,
    setKeyValue,
    paymentVisible,
    setPaymentVisible,
    userPreferences,
    setDisplayCustomerSearch,
    setOcupiedTablesData,
    setReservedTablesData,
    categorieFlag,
    setCategorieFlag,
    setCart,
    showProducts,
    setShowProducts,
    setProductsData,
    saleTypeProducts,
    setSaleTypeProducts,
    requestPayment,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    setAmount,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    processOrder,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    handleAmount,
    handleCashPayment,
    showSplitBill,
    setShowSplitBill,
    splitBillScreen,
    setSplitBillScreen,
    numSplits,
    setNumSplits,
    showAllItems,
    setShowAllItems,
    splitCarts,
    setSplitCarts,
    saleType,
    selectedTable,
    isSplitBill,
    setIsSplitBill,
    currentSplitIndex,
    setCurrentSplitIndex,
    recordState,
    setRecardState,
    documentSequence,
    setDocumnetSequence,
    clearCart,
    removeSplit,
    setRemoveSplit,
    mainTableData,
    setMainTableData,
    clearProductSearchResults,
    // Keyboard,
    setOpen,
    setInputName,
    keyboard,
    handleSelectProduct,
    selectedProductInCart,
    selectedProducts,
    setSelectedproducts,
    showSendToKitchen,
    setShowSendToKitchen,
    setSearchhistoryInput,
    searchHistoryInput,
    setFireItems,
    fireItems,
    fireMode,
    setFireMode,
    pendingFireItems,
    setPendingFireItems,
    handleCopyKOT,
    copyKOTVisible,
    setCopyKOTVisible,
    groupedFiredItems,
    setGroupedFiredItems,
    openCopyKOTModal,
    selectedCopyItems,
    setSelectedCopyItems,
    seatGuestDrawerOpen,
    setSeatGuestDrawerOpen,
    transferBill,
    setTransferBill,
    setOederedData,
    handleDisplayOk,
    productsList,
    setTableList,
    setTableCards,
    cancelKotItems,
    setCancelKotItems,
    openDisplayParkedBillModal,
    filterdParkedList,
    setFilterdParkedList,
    retrieveParkedData,
    discardMessage,
    parkedList,
    setParkedList,
    handleBillPrint,
    displayAddOnSelection,
    setDisplayAddOnSelection,
    setSelectedSaleTypeIndex,
    addonSourceItem,
    setAddonSourceItem,
    showAddonsCustomizePopup,
    setShowAddonsCustomizePopUp,
    addonRepeatDisabled,
    setAddonRepeatDisabled,
    selectedProduct,
    setSelectedProduct,
    setAddOnsList,
    addOnsList,
    handleAddOnModal,
    productSearchInput,
    setProductSearchInput,
    restaurantButtonLoading,
    setRestaurantButtonLoading,
  } = props;
  const localCart = JSON.parse(localStorage.getItem("cartObj"));
  const { t } = useTranslation();
  const { Text, Title } = Typography;
  const [productCategoriesList, setProductCategoriesList] = useState([]);
  //const [productSearchInput, setProductSearchInput] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemNotes, setSelectedItemNotes] = useState("");
  const [notesValue, setNotesValue] = useState("");
  const [notesPopup, setNotesPopup] = useState(false);
  const [categorieName, setCategorieName] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [instructions, setInstructions] = useState(notesValue);
  // const [selectedProduct, setSelectedProduct] = useState(null);
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tillaccess = JSON.parse(tillData.tillAccess.userAccessController);
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const showImage = posConfig?.showImage === "Y";
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  // Add ONS Modal Starts //
  const [categoryLookup, setCategoryLookup] = useState({});
  const [groupedProducts, setGroupedProducts] = useState([]);
  //const [selectedProduct, setSelectedProduct] = useState({});
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { dispatchEvent } = useEventBus();
  const [isAllParkedState, setIsAllParkedState] = useState(false);
  const [additionalCharges, setAdditionalCharges] = useState(false);
  const [serviceChargeEnabled, setServiceChargeEnabled] = useState(false);
  const [serviceChargePercentage, setServiceChargePercentage] = useState(5);
  const [tipMode, setTipMode] = useState("Percentage");
  const [tipPercentage, setTipPercentage] = useState(0);
  const [tipAmount, setTipAmount] = useState(0);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [packingCharge, setPackingCharge] = useState(0);
  const [roundingOption, setRoundingOption] = useState("No Rounding");
  const [categorySearch, setCategorySearch] = useState("");
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [selectCategotyList, setSelectCategotyList] = useState([]);
  const [loading, setLoading] = useState(false); // Optional, for loading state
  const productPanelSearchRef = useRef(null);
  const [defaultCategorySet, setDefaultCategorySet] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const allItemsFired = cart?.items?.length > 0 && cart?.items?.every((i) => i.order === "Y");
  const [showReprintKotDialog, setShowReprintKotDialog] = useState(false);
  //const [showSendToKitchen, setShowSendToKitchen] = useState(false);
  const [itemSplitMap, setItemSplitMap] = useState({});
  // const [copyFire, setCopyFire] = useState(false);
  const toFixedTruncate = (num, decimalPlaces = 3) => {
    if (isNaN(num) || num === null) num = 0;
    const factor = Math.pow(10, decimalPlaces);
    const truncatedNum = Math.trunc(num * factor) / factor;
    const result = truncatedNum.toFixed(decimalPlaces);
    return result;
  };
  const [splitOnItem, setSplitOnItem] = useState(false);
  const [groupedItems, setGroupedItems] = useState([]);
  const [categorySplitSelection, setCategorySplitSelection] = useState({});
  const [openCategory, setOpenCategory] = useState(null);
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y" ? true : false;
  const [salesRepName, setSalesRepName] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [parkedDrawerOpen, setParkedDrawerOpen] = useState(false);
  const storedParkedList = JSON.parse(localStorage.getItem("parkedList") || "[]");
  const [showProdCenterModal, setShowProdCenterModal] = useState(false);
  const [prodItem, setProdItem] = useState(null);
  const [saleTypeModalOpen, setSaleTypeModalOpen] = useState(false);
  const [saleTypeModalItem, setSaleTypeModalItem] = useState(null);
  const cartObj = JSON.parse(localStorage.getItem("cartObj")) || {};
  const userAccessController = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const layout = userAccessController.layout;
  const filteredCartObj = {
    ...cartObj,
    items: (cartObj.items || []).filter((item) => selectedItemIds.includes(item.fbOrderLineId)),
  };
  const usernameData = localStorage.getItem("username") || "";
  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
  const matchedRep = salesReps.find((rep) => rep?.name === usernameData);

  const getColSpan = () => {
    const count = (posConfig?.enableAdditionalCharges === "Y" ? 1 : 0) + (localStorage.getItem("dineIn") === "Y" ? 1 : 0) + (posConfig?.enableSplitBill === "Y" ? 1 : 0);

    return count > 0 ? Math.floor(24 / count) : 24;
  };

  const getMinutesAgo = (parkedTime) => {
    if (!parkedTime) return "";

    // Convert "YYYY-MM-DD HH:mm:ss" → Date
    const parkedDate = new Date(parkedTime.replace(" ", "T"));
    const now = new Date();

    const diffMs = now - parkedDate;
    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    if (diffMinutes < 1) return "Just now";
    if (diffMinutes < 60) return `${diffMinutes} min ago`;

    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours} hr ago`;

    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays} day ago`;
  };

  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  const ParkedOrderCard = ({ orderData, orderId, name, time, items, total, productList }) => {
    return (
      <div
        style={{
          background: "#FFFFFF",
          border: "1px solid #E5E7EB",
          borderRadius: "12px",
          padding: "16px",
          marginBottom: "20px",
        }}
      >
        {/* Header Line */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "0.95rem", color: "#0F0718", fontWeight: 500 }}>{orderId}</span>

            <span
              style={{
                background: "#FFE9C2",
                color: "#B27100",
                borderRadius: "6px",
                padding: "2px 8px",
                fontSize: "0.70rem",
                fontWeight: 600,
              }}
            >
              On Hold
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "0.75rem", color: "#9CA3AF" }}>
            <ClockCircleOutlined style={{ fontSize: "0.75rem", color: "#9CA3AF" }} />
            {getMinutesAgo(orderData.parkedTime)}
          </div>
        </div>

        {/* Item List Container */}
        <div
          style={{
            background: "#F9FAFB",
            borderRadius: "8px",
            padding: "5px",
            marginTop: "1vh",
            marginBottom: "14px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.85rem", fontWeight: 500 }}>
            <span>{items} item(s)</span>
            <span style={{ fontWeight: 600 }}>
              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
              {total}
              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
            </span>
          </div>

          <div
            style={{
              marginTop: "8px",
              fontSize: "0.80rem",
              color: "#0F0718",
              lineHeight: "1.3rem",
            }}
          >
            {productList.map((p, i) => (
              <div key={i}>
                {p.label}
                <span style={{ float: "right" }}>
                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                  {p.price}
                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Buttons */}
        <div style={{ display: "flex", gap: "10px" }}>
          <Button
            type="primary"
            style={{
              background: "#2F3856",
              borderColor: "#2F3856",
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 6,
              height: "34px",
              borderRadius: "8px",
              fontSize: "0.82rem",
              fontWeight: 500,
            }}
            onClick={() => {
              retrieveParkedData(orderData);
              setParkedDrawerOpen(false);
            }}
          >
            <PlayCircleOutlined style={{ fontSize: "0.9rem" }} />
            Retrieve
          </Button>

          <Button
            danger={false}
            style={{
              borderRadius: "8px",
              border: "1px solid #E5E7EB",
              width: "38px",
              height: "34px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#FFFFFF",
            }}
            onClick={() => {
              discardMessage("Discard Sale", "Are you sure you want to discard the sale!", orderData);
            }}
            icon={<DeleteOutlined style={{ color: "#9CA3AF" }} />}
          />
        </div>
      </div>
    );
  };

  const isReturnOrder = localCart?.isReturn === true || localCart?.isReturn === "true" || localCart?.isReturn === "Y";

  const handleAdvanceToggle = (checked) => {
    const updatedCart = { ...cart };

    if (!cart.wasLayaway) {
      // New order
      if (checked) {
        updatedCart.layAway = "Y";
        updatedCart.preOrder = "Y";
        updatedCart.statusType = "layAway";
        updatedCart.isAdvance = "Y";
      } else {
        updatedCart.layAway = "N";
        updatedCart.preOrder = "N";
        updatedCart.statusType = "";
        updatedCart.isAdvance = "N";
      }
    }

    if (cart.wasLayaway) {
      updatedCart.isAdvance = checked ? "Y" : "N";
      updatedCart.finishLayaway = !checked;
      updatedCart.layAway = "Y";
      updatedCart.statusType = checked ? "layAway" : "";
    }

    setCart(updatedCart);
    localStorage.setItem("cartObj", JSON.stringify(updatedCart));
  };

  const toggleCategory = (index) => {
    setOpenCategory(openCategory === index ? null : index);
  };

  const guestName = JSON.parse(localStorage.getItem("tableName"))?.guestName;
  const isGuestPresent = !!guestName;

  const groupedKotItems = useMemo(() => {
    const result = {};
    (cart?.items || []).forEach((item) => {
      const key = item.kotTokenId || "NO_KOT";
      if (!result[key]) result[key] = [];
      result[key].push(item);
    });
    return result;
  }, [cart?.items]);

  const toggleItem = (fbOrderLineId) => {
    setSelectedItemIds((prev) => (prev.includes(fbOrderLineId) ? prev.filter((id) => id !== fbOrderLineId) : [...prev, fbOrderLineId]));
  };

  const toggleKot = (items, checked) => {
    const ids = items.map((i) => i.fbOrderLineId);
    setSelectedItemIds((prev) => (checked ? Array.from(new Set([...prev, ...ids])) : prev.filter((id) => !ids.includes(id))));
  };

  // const toggleAll = (checked) => {
  //   setSelectedItemIds(checked ? cart.items.map((i) => i.lineId) : []);
  // };

  const toggleAll = (checked) => {
    if (!checked) {
      setSelectedItemIds([]);
      return;
    }

    const cancellableIds = Object.values(groupedKotItems)
      .flat()
      .filter((item) => item.isCanceled !== "Y" && (item.orderStatus === "OR" || item.orderStatus === "IP"))
      .map((item) => item.fbOrderLineId);

    setSelectedItemIds(cancellableIds);
  };

  const groupedByKot = useMemo(() => {
    const groups = {};

    (cart?.items || []).forEach((item) => {
      const token = item.kotTokenId || "NO_KOT";
      if (!groups[token]) {
        groups[token] = [];
      }
      groups[token].push(item);
    });

    return groups;
  }, [cart?.items]);

  useEffect(() => {
    const getSalesRepName = async () => {
      const tableData = JSON.parse(localStorage.getItem("tableName"));
      if (tableData) {
        const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableData?.cwrFbTableId).first();
        if (tableRecord) {
          if (tableRecord?.waiter) {
            tillData.tillAccess.csBunit.salesRep?.find((rep) => {
              if (rep?.salesRepresentId === tableRecord?.waiter) {
                setSalesRepName(rep?.name);
              }
            });
          }
        }
      }
    };
    getSalesRepName();
  }, []);

  const categoryCounts = useMemo(() => {
    return saleTypeProducts.reduce((acc, product) => {
      const categoryId = product.mProductCategoryId || "uncategorized";
      acc[categoryId] = (acc[categoryId] || 0) + 1;
      return acc;
    }, {});
  }, [saleTypeProducts]);

  const handleCategoryClick = async (categoryId, categoryName) => {
    setLoading(true);
    setSelectedCategory(categoryId);
    setCategorieName(categoryName);

    try {
      // Assuming restaurantProductCategory fetches and updates productsData
      await restaurantProductCategory(categoryId);
      setProductSearchInput("");
      let filteredProducts = [];

      if (productSearchInput.trim().length > 0) {
        const searchInput = productSearchInput.toLowerCase();
        filteredProducts = saleTypeProducts.filter((product) => {
          const matchesName = product.name?.toLowerCase().includes(searchInput);
          const matchesValue = product.value?.toLowerCase().includes(searchInput);
          const matchesUPC = product.upc?.toLowerCase().includes(searchInput);
          const matchesAlias = product?.productAliasName?.toLowerCase().includes(searchInput);
          return product.mProductCategoryId === categoryId && (matchesName || matchesValue || matchesUPC || matchesAlias) && product.isBestSeller;
        });
      } else {
        // No search → show all bestsellers in this category
        filteredProducts = saleTypeProducts.filter((product) => product.mProductCategoryId === categoryId && product.isBestSeller);
      }

      setProductsData(filteredProducts);
    } catch (error) {
      console.error("Error in restaurantProductCategory:", error);
    }

    setCategorieFlag(true);
    setLoading(false);
  };

  const getFoodTypeIcon = (foodType) => {
    if (!foodType) return null; // if empty, don't show anything
    if (foodType === "VEG") return vegIcon;
    if (foodType === "NVG") return removeBg;
    if (foodType === "EGG") return eggIcon;
    return null;
  };

  const bestsellerCategories = useMemo(
    () => productCategoriesList.filter((category) => saleTypeProducts.some((product) => product.mProductCategoryId === category.mProductCategoryId && product.isBestSeller)),
    [productCategoriesList, saleTypeProducts]
  );
  const productionCentersOptions = useMemo(() => {
    if (!productsList || productsList.length === 0) return [];

    const centersMap = new Map();

    productsList.forEach((item) => {
      const id = item.productionCenterId?.trim();

      if (id && !centersMap.has(id)) {
        const name = item.productionCenter?.trim() || id;
        centersMap.set(id, { label: name, value: id });
      }
    });

    return Array.from(centersMap.values());
  }, [productsList]);
  const pastelColors = ["#F8C8DC", "#FFD1D1", "#FFE5B4", "#FFF4C1", "#D4F4DD", "#C8E6F5", "#D1E8FF", "#E6E6FA", "#F0D4F0", "#FFE4E1", "#E0F7FA", "#F5F5DC"];

  const getColorFromId = (id) => {
    const hash = id.split("").reduce((a, b) => a + b.charCodeAt(0), 0);
    return pastelColors[hash % pastelColors.length];
  };

  useEffect(() => {
    if (filterDrawer && productCategoriesList.length > 0) {
      // pick the first category (sorted alphabetically if you want)
      const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));
      const firstCategory = sortedCategories[0];

      if (firstCategory) {
        setSelectCategotyList([firstCategory.mProductCategoryId]);
        setCategorieName(firstCategory.name);
        setSelectedCategory(firstCategory.mProductCategoryId);

        // fetch and set products for this category
        restaurantProductCategory(firstCategory.mProductCategoryId);
        setCategorieFlag(true);
      }
    }
  }, [filterDrawer, productCategoriesList]);

  useEffect(() => {
    if (productSearchInput.length > 0) {
      const searchedProducts = saleTypeProducts.filter((product) => {
        const searchInput = productSearchInput.toLowerCase();
        const matchesName = product.name?.toLowerCase().includes(searchInput);
        const matchesValue = product.value?.toLowerCase().includes(searchInput);
        const matchesUPC = product.upc?.toLowerCase().includes(searchInput);
        const matchesAlias = product?.productAliasName?.toLowerCase().includes(searchInput);
        return matchesName || matchesValue || matchesUPC || matchesAlias;
      });

      if (searchedProducts.length > 0) {
        setSelectedCategory(searchedProducts[0].mProductCategoryId);
      }
    }
  }, [productSearchInput, saleTypeProducts]);

  useEffect(() => {
    if (!defaultCategorySet && productCategoriesList.length > 0 && saleTypeProducts.length > 0 && bestsellerCategories.length > 0) {
      const sortedCategories = [...bestsellerCategories].sort((a, b) => a.name.localeCompare(b.name));
      if (sortedCategories[0]) {
        setSelectedCategory(sortedCategories[0].mProductCategoryId);
        setDefaultCategorySet(true);
      }
      if (bestsellerCategories.length > 0 && !selectedCategory) {
        setSelectedCategory(bestsellerCategories[0].mProductCategoryId);
      }
    }
  }, [bestsellerCategories, productCategoriesList, saleTypeProducts, defaultCategorySet]);

  const frequentProducts = productsData.filter((item) => item.isBestSeller);
  const nonfrequentProducts = productsData.filter((item) => !item.isBestSeller);

  const applySearchFilter = (searchValue, categoryIds) => {
    const value = searchValue.toLowerCase().trim();

    if (!value) {
      // Only category filter
      if (categoryIds.length === 0) return saleTypeProducts;
      return saleTypeProducts.filter((product) => categoryIds.includes(product.mProductCategoryId));
    }

    return saleTypeProducts.filter((product) => {
      const matchesText =
        product.name.toLowerCase().includes(value) ||
        product.value?.toLowerCase().includes(value) ||
        product.code?.toLowerCase().includes(value) ||
        product?.productAliasName?.toLowerCase().includes(value);

      const matchesCategory = categoryIds.length === 0 || categoryIds.includes(product.mProductCategoryId);

      return matchesText && matchesCategory;
    });
  };

  useEffect(() => {
    console.log("selected", selectedProduct, addOnsList);
  }, [selectedProduct]);

  const handleCopyKOTConfirm = async () => {
    const selectedProductIds = Object.keys(selectedCopyItems).filter((productId) => selectedCopyItems[productId] > 0);

    if (selectedProductIds.length === 0) {
      message.warning("Please select at least one item to copy");
      return;
    }

    // 1. Create new items based on selected fired items
    const newItems = selectedProductIds.map((productId) => {
      const originalItem = cart.items.find((i) => i.productId === productId);
      const selectedQty = selectedCopyItems[productId];

      const originalQty = originalItem.weight || 1;

      // ✅ derive PER-UNIT values from fired item
      const unitNetTotal = (originalItem.nettotal || 0) / originalQty;
      const unitLineGross = (originalItem.linegross || 0) / originalQty;
      const unitLineNet = (originalItem.linenet || 0) / originalQty;
      const unitTax = (originalItem.taxRate || 0) / originalQty;

      return {
        ...originalItem,

        lineId: uuidv4().replace(/-/g, "").toUpperCase(),

        // ✅ qty user selected
        weight: selectedQty,
        sendQty: selectedQty,
        firedQty: 0,
        order: "N",

        // ✅ recomputed totals
        nettotal: parseFloat(unitNetTotal * selectedQty).toFixed(pricePrecision),
        linegross: parseFloat(unitLineGross * selectedQty).toFixed(pricePrecision),
        linenet: parseFloat(unitLineNet * selectedQty).toFixed(pricePrecision),
        taxRate: parseFloat(unitTax * selectedQty).toFixed(pricePrecision),
      };
    });

    // 2. Update cart with copied items
    const updatedCart = {
      ...cart,
      items: [...cart.items, ...newItems],
      total: cart.total + newItems.reduce((sum, item) => sum + item.nettotal, 0),
    };

    // 3. Close Copy KOT modal immediately
    setCopyKOTVisible(false);
    setSelectedCopyItems({});

    // 4. Mark copied items as ordered (fired) in the cart
    const cartWithFiredItems = {
      ...updatedCart,
      items: updatedCart.items.map((cartItem) => {
        const isCopiedItem = newItems.some((i) => i.lineId === cartItem.lineId);
        return isCopiedItem ? { ...cartItem, order: "Y", firedQty: cartItem.weight } : cartItem;
      }),
    };

    // 5. Update cart state and localStorage
    setCart(cartWithFiredItems);
    localStorage.setItem("cartObj", JSON.stringify(cartWithFiredItems));

    // 6. Fire items to kitchen directly (same flow as single fire)
    await handleCopyKOTFire(newItems, cartWithFiredItems);

    message.success("Items copied and sent to kitchen successfully!");
  };

  const handleCopyKOTFire = async (copiedItems, updatedCart) => {
    try {
      let orderId = localStorage.getItem("orderId") === null ? 1 : Number(localStorage.getItem("orderId")) + 1;
      localStorage.setItem("orderId", orderId);

      let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
      let tableInfo = JSON.parse(localStorage.getItem("tableName"));

      if (recordState) {
        recordState.uniqId = uniqId;
      }
      localStorage.setItem("tableName", JSON.stringify(recordState));

      let newCart = {
        ...updatedCart,
        tableNo: recordState?.table,
      };

      // Mark all items as parked
      newCart?.items?.forEach((cartItem) => (cartItem.parkedItem = true));

      let orderLines = [];

      if (recordState?.cwrFbTableId) {
        // Get existing order or create new one
        const existingFbOrder = await db.fbOrderData.where("cwrFbTableId").equals(recordState.cwrFbTableId).first();
        let fbOrder;
        let fbOrderId;

        if (existingFbOrder) {
          fbOrder = existingFbOrder;
          fbOrderId = existingFbOrder.fbOrderId;
        } else {
          const fbOrders = JSON.parse(localStorage.getItem("getFBOrderData") || "[]");
          const filteredOrders = Array.isArray(fbOrders) ? fbOrders.filter((o) => o.fbTableId === recordState?.cwrFbTableId || o.fbTableId === recordState?.fbTableId) : [];
          const fbOrderDataID = filteredOrders[0]?.fbOrderId;
          fbOrderId = fbOrderDataID || uuidv4().replace(/-/g, "").toUpperCase();
          fbOrder = {
            fbOrderId,
            cwrFbTableId: recordState?.cwrFbTableId,
            fbOrderStatus: "IP",
            lines: [],
            fbOrderSync: "N",
            cart: newCart,
            name: recordState?.table,
            noOfPersons: recordState?.noOfPersons,
            statusType: "OCU",
            dineIn: localStorage.getItem("dineIn"),
            uniqId: uniqId,
          };
        }

        // Update table status to ONG (Ongoing)
        await db.tableData
          .where("cwrFbTableId")
          .equals(recordState?.cwrFbTableId)
          .modify((eventValue) => {
            eventValue.items = newCart.items;
            eventValue.totalAmount = newCart.total;
            eventValue.documentno = newCart.documentno;
            eventValue.time = moment(new Date()).format(userPreferences.dateTimeFormat);
            eventValue.statusType = "ONG";
            eventValue.tableSync = "N";
          });

        // Create order lines for copied items
        copiedItems.forEach((item) => {
          let fbOrderLineId = uuidv4().replace(/-/g, "").toUpperCase();
          let fbMetaOrderId = uuidv4().replace(/-/g, "").toUpperCase();
          const lineId = item.lineId;
          const usedKeysLower = new Set([
            "productid",
            "mbatchid",
            "description",
            "uom",
            "tax",
            "discount",
            "weight",
            "unitprice",
            "listprice",
            "linegross",
            "lineid",
            "grossstd",
            "name",
            "value",
            "grossunit",
            "linestd",
            "netlist",
            "netstd",
            "netunit",
            "unittax",
            "order",
          ]);

          const metaFromItem = Object.fromEntries(Object.entries(item).filter(([key]) => !usedKeysLower.has(key.toLowerCase())));
          const metaString = {
            ...metaFromItem,
            lineId,
            fbMetaOrderId,
            fbOrderLineId,
            isSelected: "N",
            order: "Y",
          };

          item.fbOrderLineId = fbOrderLineId;
          orderLines.push({
            fbOrderId: `${fbOrderId}`,
            fbOrderLineId: `${fbOrderLineId}`,
            lineId: lineId,
            mPoductId: `${item.productId || item.mPoductId}`,
            mBatchId: item.mBatchId,
            description: `${item.description || ""}`,
            csUomId: `${item.uom}`,
            csTaxId: `${item.tax}`,
            discount: item.discount,
            line: 1,
            qty: item.weight,
            unitPrice: item.unitPrice,
            listPrice: item.listPrice,
            lineNet: item.linenet,
            lineTax: item.taxRate,
            lineGross: item.linegross,
            sOrderLineId: null,
            isOrdered: "Y",
            isCanceled: "N",
            grossStd: item.grossstd,
            grossUnit: item.grossunit,
            lineStd: item.linestd,
            netList: item.netList,
            netStd: item.netStd,
            netUnit: item.netunit,
            unitTax: item.unitTax,
            meta: [
              {
                key: "orderLine",
                value: JSON.stringify(metaString),
                fbOrderLineMetaId: `${fbMetaOrderId}`,
              },
            ],
          });
        });

        // Group items by production center for KOT printing
        let array1 = [];
        for (let i = 0; i < newCart.items.length; i++) {
          let item = newCart.items[i];
          let printer = item.productionCenter;
          if (!array1.hasOwnProperty(`${printer}`)) {
            array1[`${printer}`] = [];
          }
          array1[`${printer}`].push(newCart.items[i]);
        }

        // Print KOT
        if (posConfig?.enableKOTPrint === "Y") {
          if (CWHardwareController) {
            const filteredCart = {
              ...newCart,
              items: copiedItems, // Only print copied items
            };
            CWKOTPrinter(filteredCart);
          } else {
            kotPrinter(array1, fbOrder.fbOrderId);
          }
        }

        // Update order in database
        fbOrder.lines = orderLines;
        fbOrder.fbOrderSync = "N";
        fbOrder.cart = newCart;

        await db.fbOrderData.put(fbOrder, fbOrderId);
        await SyncData(fbOrder, "upsertFbOrder", setLoading, "", true, newCart);

        // Sync table status
        const updatedTableData = await db.tableData.toArray();
        const updatedTable = updatedTableData.find((t) => t.cwrFbTableId === recordState?.cwrFbTableId);

        if (updatedTable) {
          await SyncData(updatedTable, "upsertTableStatus");
        }

        // Update table lists
        setTableCards(updatedTableData);
        const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU" || table.statusType === "ONG");
        setOcupiedTablesData(ocuTables);
        const resTables = updatedTableData.filter((table) => table.statusType === "RES");
        setReservedTablesData(resTables);

        let tempData = [];
        await db.tableData.toArray().then((fetched) => {
          tempData.push(...fetched);
        });
        setTableList(tempData);

        // Navigate back to tables after short delay (like regular fire)
        setTimeout(() => {
          setShowProducts(false);
          setKeyValue("0");
        }, 1500);
      }
    } catch (error) {
      console.error("[v0] Error in handleCopyKOTFire:", error);
      message.error("Failed to send items to kitchen");
    }
  };

  const applyRounding = (value, precision = pricePrecision) => {
    if (isNaN(value) || value === null) return 0;
    const factor = Math.pow(10, precision);
    switch (roundingOption) {
      case "Round Up":
        return Math.ceil(value * factor) / factor;
      case "Round Down":
        return Math.floor(value * factor) / factor;
      case "No Rounding":
      default:
        return parseFloat(toFixedTruncate(value, precision));
    }
  };

  const subtotal = cart?.subTotal || 0;
  const serviceChargeAmount = applyRounding(serviceChargeEnabled ? (subtotal * serviceChargePercentage) / 100 : 0);
  const tipTotal = applyRounding(tipMode === "Percentage" && tipPercentage > 0 ? (subtotal * tipPercentage) / 100 : tipAmount);
  const deliveryChargeAmount = applyRounding(deliveryCharge);
  const packingChargeAmount = applyRounding(packingCharge);
  const AdditionalChargesTotal = serviceChargeAmount + tipTotal + deliveryChargeAmount + packingChargeAmount;

  useEffect(() => {
    let cartObj = JSON.parse(localStorage.getItem("cartObj")) ? JSON.parse(localStorage.getItem("cartObj")) : cart;
    const allParked = cart?.items?.length > 0 && cart?.items?.every((item) => item.parkedItem === true);
    const hasUnparkedItems = cart.items.some((item) => item.parkedItem === false);

    // const sameProductQtyIncreased = cart.items.some((item) => item.productId === selectedProductInCart?.productId);
    const hasPendingToSend = cartObj?.items?.some((item) => item.sendQty > 0);
    if (hasUnparkedItems || hasPendingToSend) {
      setShowSendToKitchen(true);
      setIsAllParkedState(false);
    } else {
      setShowSendToKitchen(false);
      setIsAllParkedState(allParked);
    }
  }, [cart?.items]);

  useEffect(() => {
    const matchedProduct = cart.items.find((item) => item.productId === selectedProductInCart?.productId);
    setSelectedproducts((prev) => [...prev, matchedProduct]);
  }, [selectedProductInCart]);

  useEffect(() => {
    setProductSearchInput("");
    setCategorieFlag(false);
  }, []);

  const handleShift = () => {
    layoutName === "default" ? setLayoutName("shift") : setLayoutName("default");
  };

  const handleAdditionalCharges = async () => {
    setAdditionalCharges(true);
  };

  const handleApplyCharges = () => {
    setAdditionalCharges(false);
    const localCart = JSON.parse(localStorage.getItem("cartObj"));
    if (localCart) {
      // const updatedTotal = parseFloat(localCart.total || 0) + parseFloat(AdditionalChargesTotal || 0);
      // localCart.total = updatedTotal;
      localCart.serviceCharge = serviceChargeAmount;
      localCart.tip = tipTotal;
      localCart.deiveryCharge = deliveryChargeAmount;
      localCart.packingCharge = packingChargeAmount;
      localStorage.setItem("cartObj", JSON.stringify(localCart));
      setCart(localCart);
    }
  };

  const resetToInitialState = () => {
    setServiceChargeEnabled(false);
    setServiceChargePercentage(5);
    setTipMode("Percentage");
    setTipPercentage(0);
    setTipAmount(0);
    setDeliveryCharge(0);
    setPackingCharge(0);
    setRoundingOption("No Rounding");
    const localCart = JSON.parse(localStorage.getItem("cartObj"));
    if (localCart) {
      // const updatedTotal = parseFloat(localCart.total || 0) - parseFloat(AdditionalChargesTotal || 0);
      // localCart.total = updatedTotal;
      localCart.serviceCharge = 0;
      localCart.tip = 0;
      localCart.deiveryCharge = 0;
      localCart.packingCharge = 0;
      localStorage.setItem("cartObj", JSON.stringify(localCart));
      setCart(localCart);
    }
  };

  // const handleAddOnModal = (record, event) => {
  //   console.log("record for addons", record);
  //   event.stopPropagation();
  //   setDisplayAddOnSelection(true);
  //   setSelectedProduct(record);

  //   const requiredListFilter = _.filter(record.productAddons, (item) => item.mAddonGroup.minqty === 1);
  //   const optionsListFilter = _.filter(record.productAddons, (item) => item.mAddonGroup.minqty === 0);
  //   setAddOnsList({
  //     requiredList: requiredListFilter,
  //     optionsList: optionsListFilter,
  //   });
  // };

  const handleAddOnValue = (e, fieldName) => {
    const value = e.target.value;
    const groupId = value.mAddonGroup.mAddonGroupId;
    const max = value.mAddonGroup.maxqty;

    let newSelectedAddons = [...selectedAddons];

    // RADIO → always single for that group
    if (fieldName === "addOnRadio") {
      newSelectedAddons = newSelectedAddons.filter((item) => item.mAddonGroup.mAddonGroupId !== groupId);
      newSelectedAddons.push(value);
      setSelectedAddons(newSelectedAddons);
      return;
    }

    // CHECKBOX GROUP ITEMS
    const groupItems = newSelectedAddons.filter((item) => item.mAddonGroup.mAddonGroupId === groupId);

    const existsIndex = newSelectedAddons.findIndex((item) => item.mProductAddOnId === value.mProductAddOnId);

    // REMOVE
    if (existsIndex !== -1 && !e.target.checked) {
      newSelectedAddons.splice(existsIndex, 1);
      setSelectedAddons(newSelectedAddons);
      return;
    }

    // MAX CHECK
    if (groupItems.length >= max) {
      message.warning(`Max ${max} allowed in ${value.mAddonGroup.name}`);
      return;
    }

    // ADD
    newSelectedAddons.push(value);
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = {
      ...selectedProduct,
      weight: selectedProduct?.weight || 1,
    };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) - 1;
      if (newSelectedProduct.weight <= 1) {
        newSelectedProduct.weight = 1;
      }
    }

    setSelectedProduct({
      ...newSelectedProduct,
    });
  };

  const handleAdd = async () => {
    // 🔹 GROUP SELECTED ADDONS BY GROUP
    console.log("selectedAddons", selectedAddons);
    const selectedGroupMap = _.groupBy(selectedAddons, (a) => a.mAddonGroup.mAddonGroupId);

    // 🔹 GROUP ALL PRODUCT ADDONS
    const allGroups = _.groupBy(selectedProduct.productAddons, (a) => a.mAddonGroup.mAddonGroupId);

    // 🔹 VALIDATE MIN/MAX PER GROUP
    for (const groupId in allGroups) {
      const groupInfo = allGroups[groupId][0].mAddonGroup;

      const min = groupInfo.minqty ?? 0;
      const max = groupInfo.maxqty ?? Infinity;

      const selectedCount = selectedGroupMap[groupId]?.reduce((s, a) => s + (a.qty || 1), 0) || 0;

      // MIN CHECK
      if (selectedCount < min) {
        message.error(`Please select minimum ${min} from ${groupInfo.name}`);
        return;
      }

      // MAX CHECK (extra safety)
      if (selectedCount > max) {
        message.error(`You can select maximum ${max} from ${groupInfo.name}`);
        return;
      }
    }

    // 🔹 EXISTING CODE (UNCHANGED)
    const addonsWithWeight = selectedAddons.map((addon) => ({
      ...addon,
      weight: selectedProduct.weight,
      addonQty: addon.qty,
    }));

    const addonWeightFlag = true;

    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        selectedAddons: addonsWithWeight,
        weight: selectedProduct?.weight || 1,
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice,
      addonWeightFlag
    );

    handleAddOnModalClose();
  };

  const updateAddonQty = (addon, change) => {
    const groupId = addon.mAddonGroup.mAddonGroupId;
    const groupName = addon.mAddonGroup.name;
    const max = addon.mAddonGroup.maxqty ?? Infinity;
    const allowQty = addon.mAddonGroup.allowQtySelection === "Y";

    let newAddons = [...selectedAddons];

    // all items in same group
    const groupItems = newAddons.filter((a) => a.mAddonGroup.mAddonGroupId === groupId);

    const totalQtyInGroup = groupItems.reduce((sum, a) => sum + (a.qty || 0), 0);

    const index = newAddons.findIndex((a) => a.mProductAddOnId === addon.mProductAddOnId);

    /* ================= REMOVE FULLY ================= */
    if (change === -999 && index !== -1) {
      newAddons.splice(index, 1);
      setSelectedAddons(newAddons);
      return;
    }

    /* ================= ADD ================= */
    if (change === 1) {
      // allowQtySelection = Y → count qty
      if (allowQty) {
        if (totalQtyInGroup + 1 > max) {
          message.warning(`Max ${max} allowed in ${groupName}`);
          return;
        }

        if (index !== -1) {
          newAddons[index].qty += 1;
        } else {
          newAddons.push({ ...addon, qty: 1 });
        }
      }

      // allowQtySelection = N → count items only
      else {
        if (groupItems.length >= max) {
          message.warning(`Only ${max} options allowed in ${groupName}`);
          return;
        }

        if (index === -1) {
          newAddons.push({ ...addon, qty: 1 });
        }
      }
    }

    /* ================= MINUS ================= */
    if (change === -1 && index !== -1) {
      if (allowQty) {
        newAddons[index].qty -= 1;

        if (newAddons[index].qty <= 0) {
          newAddons.splice(index, 1);
        }
      } else {
        newAddons.splice(index, 1);
      }
    }

    setSelectedAddons(newAddons);
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };

  const getAddonPreview = (addons = []) => {
    if (!addons.length) return "";

    const names = addons.map((a) => a.name);

    if (names.length <= 2) return names.join(", ");

    return names.slice(0, 2).join(", ") + "…";
  };

  useEffect(() => {
    db.productCategories
      .toArray()
      .then((response) => {
        const result = response.filter((item) => {
          const filteredProducts = saleTypeProducts?.filter((product) => product?.mProductCategoryId === item?.mProductCategoryId);
          if (filteredProducts?.length > 0) {
            return item;
          }
        });
        setProductCategoriesList(result);
      })
      .catch((error) => {
        // Handle any errors that occur
        console.error(error);
      });
  }, [saleTypeProducts]);

  const showProductModal = (product) => {
    setSelectedProduct(product);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setSelectedProduct(null);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedProduct(null);
  };

  const filteredProducts = productsData.filter((product) => product.isBestSeller && product.mProductCategoryId === selectedCategory);

  useEffect(() => {
    if (productCategoriesList?.length > 0 && !filterDrawer) {
      const filtered = productCategoriesList
        .filter((category) => saleTypeProducts.some((product) => product.mProductCategoryId === category.mProductCategoryId && product.isBestSeller))
        .sort((a, b) => a.name.localeCompare(b.name));

      if (filtered.length > 0) {
        // Case 1: Best sellers available
        const firstCategory = filtered[0];
        setSelectedCategory(firstCategory.mProductCategoryId);
        setCategorieName(firstCategory.name);
        restaurantProductCategory(firstCategory.mProductCategoryId);

        setSaleTypeProducts((prev) => {
          const filteredProducts = prev.filter((product) => product.mProductCategoryId === firstCategory.mProductCategoryId && product.isBestSeller);
          setProductsData(filteredProducts);
          return prev;
        });
      } else {
        // Case 2: No best sellers -> show ALL categories & products
        const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));

        if (sortedCategories.length > 0) {
          const firstCategory = sortedCategories[0];
          setSelectedCategory(firstCategory.mProductCategoryId);
          setCategorieName(firstCategory.name);
          restaurantProductCategory(firstCategory.mProductCategoryId);

          setSaleTypeProducts((prev) => {
            const filteredProducts = prev.filter((product) => product.mProductCategoryId === firstCategory.mProductCategoryId);
            setProductsData(filteredProducts);
            return prev;
          });
        } else {
          // absolutely no categories
          setSelectedCategory(null);
          setCategorieName("");
          setProductsData([]);
        }
      }
    }
  }, [productCategoriesList, saleTypeProducts, filterDrawer]);

  useEffect(() => {
    if (productCategoriesList?.length > 0) {
      const defaultCategory = productCategoriesList[0];
      const filteredProducts = saleTypeProducts.filter((product) => product.mProductCategoryId === defaultCategory.mProductCategoryId);
      setProductsData(filteredProducts);
    } else {
      setProductsData([]);
    }
  }, [saleTypeProducts, productCategoriesList]);

  const cartItems = cart.items;
  // const cartItems = JSON.parse(localStorage.getItem("cartObj").items);
  // const cartObj = JSON.parse(localStorage.getItem("cartObj"));
  // const cartItems = cartObj ? cartObj.items : null;

  useEffect(() => {
    db.productCategories
      .toArray()
      .then((response) => {
        const lookup = response.reduce((acc, category) => {
          acc[category.mProductCategoryId.trim()] = category.name.trim();
          return acc;
        }, {});
        setCategoryLookup(lookup);
      })
      .catch((error) => {
        console.error("Error fetching product categories:", error);
      });
    const groupedProducts = cartItems?.reduce((acc, item) => {
      const categoryName = categoryLookup[item.mProductCategoryId.trim()] || "";
      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }
      acc[categoryName].push(item);
      return acc;
    }, {});

    setGroupedProducts(groupedProducts);
  }, [cartItems]);

  const hasFiredItems = Object.values(groupedProducts)
    .flat()
    .some((item) => item.order === "Y");

  useEffect(() => {
    if (!cart?.items) return;
    if (splitOnItem) {
      const initMap = {};
      cart.items.forEach((item) => {
        initMap[item.lineId] = Array(numSplits).fill(true);
      });
      setItemSplitMap(initMap);

      setSplitCarts(buildSplitCarts(cart, numSplits, initMap));
    }
  }, [splitOnItem]);

  // const buildSplitCarts = (cart, numSplits, map) => {
  //   const splits = Array.from({ length: numSplits }, (_, i) => ({
  //     ...cart,
  //     splitNo: i + 1,
  //     items: [],
  //     total: 0,
  //     tax: 0,
  //     discount: 0,
  //     deiveryCharge: 0,
  //     packingCharge: 0,
  //     tip: 0,
  //     serviceCharge: 0,
  //   }));

  //   cart.items.forEach((item) => {
  //     const flags = map[item.lineId] || Array(numSplits).fill(true);
  //     const activeIndexes = flags.map((on, idx) => (on ? idx : null)).filter((v) => v !== null);

  //     if (!activeIndexes.length) return;

  //     const shareCount = activeIndexes.length;

  //     // ✅ CORRECT SCOPE — item & shareCount EXIST HERE
  //     const netSplits = splitWithPrecision(Number(item.nettotal || 0), shareCount, pricePrecision);

  //     const taxSplits = splitWithPrecision(Number(item.taxAmount || 0), shareCount, pricePrecision);

  //     activeIndexes.forEach((splitIdx, idx) => {
  //       const s = splits[splitIdx];

  //       s.items.push({
  //         ...item,
  //         weight: item.weight,
  //         nettotal: netSplits[idx],
  //         tax: taxSplits[idx],
  //       });

  //       s.total += netSplits[idx];
  //       s.tax += taxSplits[idx];
  //     });
  //   });

  //   // ✅ FINAL ROUNDING (KEEP THIS)
  //   return splits.map((s) => ({
  //     ...s,
  //     total: +s.total.toFixed(pricePrecision),
  //     tax: +s.tax.toFixed(pricePrecision),
  //     discount: +s.discount.toFixed(pricePrecision),
  //   }));
  // };

  const buildSplitCarts = (cart, numSplits, map) => {
    const splits = Array.from({ length: numSplits }, (_, i) => ({
      ...cart,
      splitNo: i + 1,
      items: [],
      total: 0,
      tax: 0,
      discount: 0,
      deliveryCharge: 0,
      packingCharge: 0,
      tip: 0,
      serviceCharge: 0,
    }));

    cart.items.forEach((item) => {
      const flags = map[item.lineId] || Array(numSplits).fill(true);

      const activeIdx = flags.map((on, idx) => (on ? idx : null)).filter((v) => v !== null);

      if (activeIdx.length === 0) return;

      const share = activeIdx.length;

      const netSplit = Number(item.nettotal) / share;
      const taxSplit = Number(item.taxAmount || 0) / share;

      activeIdx.forEach((i) => {
        splits[i].items.push({
          ...item,
          nettotal: netSplit,
          tax: taxSplit,
        });
      });
    });

    splits.forEach((s) => {
      s.total = +s.items.reduce((sum, it) => sum + it.nettotal, 0).toFixed(pricePrecision);
      s.tax = +s.items.reduce((sum, it) => sum + it.tax, 0).toFixed(pricePrecision);
    });

    const calcTotal = splits.reduce((sum, s) => sum + s.total, 0);
    const diff = +(cart.total - calcTotal).toFixed(pricePrecision);

    if (diff !== 0) {
      const idx = splits.findIndex((s) => s.total > 0);
      if (idx !== -1) {
        splits[idx].total = +(splits[idx].total + diff).toFixed(pricePrecision);
      }
    }

    const calcTax = splits.reduce((sum, s) => sum + s.tax, 0);
    const taxDiff = +(cart.tax - calcTax).toFixed(pricePrecision);

    if (taxDiff !== 0) {
      const idx = splits.findIndex((s) => s.tax > 0);
      if (idx !== -1) {
        splits[idx].tax = +(splits[idx].tax + taxDiff).toFixed(pricePrecision);
      }
    }

    return splits;
  };

  const handleToggleItemSplit = (item, splitIndex) => {
    setSplitOnItem(true);
    setItemSplitMap((prev) => {
      const current = prev[item.lineId] || Array(numSplits).fill(true);
      const next = [...current];

      const numOn = current.filter(Boolean).length;
      if (current[splitIndex] && numOn === 1) return prev; // avoid 0 splits

      next[splitIndex] = !current[splitIndex];

      const newMap = { ...prev, [item.lineId]: next };
      const newSplitCarts = buildSplitCarts(cart, numSplits, newMap);
      setSplitCarts(newSplitCarts);
      setSplitOnItem(false);
      return newMap;
    });
  };

  const assignWholeCategory = (group, splitIndexToRemove, undo = false) => {
    setItemSplitMap((prev) => {
      let updated = { ...prev };

      group.items.forEach((item) => {
        // WHEN UNDO → restore all ON
        if (undo) {
          updated[item.lineId] = Array(numSplits).fill(true);
          return;
        }

        // remove selected split logic
        const current = prev[item.lineId] || Array(numSplits).fill(true);
        const numOn = current.filter(Boolean).length;

        if (current[splitIndexToRemove] && numOn === 1) {
          updated[item.lineId] = current;
          return;
        }

        const arr = Array(numSplits).fill(true);
        arr[splitIndexToRemove] = false;

        updated[item.lineId] = arr;
      });

      const newSplitCarts = buildSplitCarts(cart, numSplits, updated);
      setSplitCarts(newSplitCarts);

      return updated;
    });
  };

  const splitWithPrecision = (amount, splits, precision) => {
    const factor = Math.pow(10, precision);

    // truncate base
    const base = Math.floor((amount / splits) * factor) / factor;

    // total distributed after truncation
    const distributed = base * splits;

    // remainder to distribute
    let remainder = Math.round((amount - distributed) * factor);

    // find next digit
    const nextDigit = Math.floor(((amount / splits) * factor * 10) % 10);

    const results = Array(splits).fill(base);

    if (remainder > 0) {
      if (nextDigit >= 5) {
        // 🔼 increase many, keep one lower
        for (let i = 0; i < remainder; i++) {
          results[i] += 1 / factor;
        }
      } else {
        // 🔼 increase one only
        results[results.length - 1] += remainder / factor;
      }
    }

    return results.map((v) => +v.toFixed(precision));
  };

  const totalSplits = splitWithPrecision(cart.total, numSplits, pricePrecision);

  const taxSplits = splitWithPrecision(cart.tax, numSplits, pricePrecision);

  const renderWaiterName = () => {
    if (salesRepName && localStorage.getItem("dineIn") === "Y") {
      return (
        <span
          style={{
            marginLeft: "auto",
            fontSize: "0.85em",
            fontWeight: 500,
            color: "#0F0718",
            whiteSpace: "nowrap",
          }}
        >
          {salesRepName}
        </span>
      );
    }
  };

  const isProductInCart = (product, cart) => {
    return cart?.items?.some(
      (item) => item.productId === product.productId
      // item.upc === product.upc &&
      // item.mBatchId === product.mBatchId &&
      // !item.isReturn
    );
  };

  const getProductLinesInCart = (product, cart) => {
    return cart.items.filter((item) => item.productId === product.productId && !item.isReturn && item.selectedAddons?.length > 0);
  };

  const getAddonSignature = (selectedAddons = []) => {
    return selectedAddons
      .map((a) => a.mProductAddOnId)
      .sort()
      .join("|");
  };

  const updateTableStatusToBRQ = async () => {
    if (localStorage.getItem("dineIn") !== "Y") return;

    const tableInfo = JSON.parse(localStorage.getItem("tableName") || "null");
    if (!tableInfo?.cwrFbTableId) return;

    const tableRecord = await db.tableData.where("cwrFbTableId").equals(tableInfo.cwrFbTableId).first();

    if (!tableRecord) return;

    // 🔹 only update if not already BRQ
    if (tableRecord.statusType !== "BRQ") {
      tableRecord.statusType = "BRQ";
      tableRecord.tableSync = "N";

      await db.tableData.put(tableRecord, tableRecord.cwrFbTableId);

      // optional sync
      await SyncData(tableRecord, "upsertTableStatus");

      // update UI
      setTableCards?.((prev) => prev.map((t) => (t.cwrFbTableId === tableRecord.cwrFbTableId ? { ...t, ...tableRecord } : t)));

      setTableList?.((prev) => prev.map((t) => (t.cwrFbTableId === tableRecord.cwrFbTableId ? { ...t, ...tableRecord } : t)));
    }
    localStorage.setItem("isPreparedBill", true);
  };

  const handlePayBillClick = async () => {
    await updateTableStatusToBRQ(); // 👈 new function
  };

  const renderPrepareBill = () => {
    if (localStorage.getItem("dineIn") === "Y") {
      return (
        <Col
          span={Math.floor(
            24 / ((posConfig?.enableAdditionalCharges === "Y" ? 1 : 0) + (localStorage.getItem("dineIn") === "Y" ? 1 : 0) + (posConfig?.enableSplitBill === "Y" ? 1 : 0))
          )}
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            padding: "1vh 0 0 0.5vw",
            justifyContent: "right",
          }}
        >
          <Button
            style={{
              width: "100%",
              border: "1px solid rgba(146, 144, 152, 0.5)",
              borderRadius: "10px",
              color: "#2F3856",
              height: "5.5vh",
              fontSize: "1em",
              fontWeight: "500",
            }}
            onClick={() => {
              handlePayBillClick();
              const cartOBJ = JSON.parse(localStorage.getItem("cartObj")) || {};
              const finalCartObj = { ...cartOBJ, unsettled: true };
              PrintController(finalCartObj);
            }}
          >
            Prepare Bill
          </Button>
        </Col>
      );
    }
  };

  const renderCancelPayBillButtons = () => {
    return (
      <div>
        <Space direction="horizontal" style={{ paddingTop: "2vh", fontSize: "1vw" }}>
          {/* {localStorage.getItem("dineIn") === "Y" && ( */}
          {posConfig?.allowCancelKOT === "Y" && (
            // cart.length > 0 && cart.some((item) => item.parkedItem === true) &&
            <Button
              // onClick={() => handleVoid(selectedTable)}
              onClick={() => setCancelKotItems(true)}
              style={{
                width: !matchedRep || tillaccess?.waiterPayment === "Y" ? "7.8vw" : "28vw",
                border: "1px solid rgba(146, 144, 152, 0.5)",
                borderRadius: "10px",
                color: "#2F3856",
                height: "6vh",
                fontSize: "1em",
                fontWeight: "500",
              }}
            >
              {getMultilingualText("Cancel")}
            </Button>
          )}
          {!matchedRep || tillaccess?.waiterPayment === "Y" ? (
            <Button
              disabled={
                localStorage.getItem("dineIn") === "N"
                  ? cart.items.length === 0 // TAKEAWAY: enable if items exist
                  : !allItemsFired // DINE-IN: enable only if all fired
              }
              onClick={async () => {
                // TAKEAWAY → No need to check allItemsFired
                if (localStorage.getItem("dineIn") !== "N" && !allItemsFired) return;

                if (isAllParkedState || localStorage.getItem("dineIn") === "N") {
                  if (saleType === "TA") {
                    const cartObj = JSON.parse(localStorage.getItem("cartObj"));
                    let updatedCart = {
                      ...cartObj,
                      // sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                      sOrderID: cartObj?.preOrder === "Y" ? cartObj.sOrderID : uuidv4().replace(/-/g, "").toUpperCase(),
                    };
                    setCart(updatedCart);
                    localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                  }
                  setPaymentVisible(true);

                  setTimeout(() => {
                    paymentModalInputRef.current?.focus();
                    paymentModalInputRef.current?.select();
                  }, 200);
                } else {
                  try {
                    setLoading(true);
                    await handleOrder();
                  } finally {
                    setLoading(false);
                  }
                }
              }}
              disabled={loading}
              style={{
                width: posConfig?.allowCancelKOT === "N" ? "27.5vw" : "19.5vw",
                borderRadius: "10px",
                backgroundColor: localStorage.getItem("dineIn") === "N" ? (cart.items.length > 0 ? "#2F3856" : "#999") : allItemsFired ? "#2F3856" : "#999",
                cursor: localStorage.getItem("dineIn") === "N" ? (cart.items.length > 0 ? "pointer" : "not-allowed") : allItemsFired ? "pointer" : "not-allowed",
                color: "#fff",
                height: "6vh",
                fontSize: "1em",
                fontWeight: "500",
                opacity: localStorage.getItem("dineIn") === "N" ? (cart.items.length > 0 ? 1 : 0.5) : allItemsFired ? 1 : 0.5,
              }}
            >
              Pay Bill
            </Button>
          ) : null}
        </Space>
      </div>
    );
  };

  const renderAddtionalChargesPrepareSplitBillButtons = () => {
    if ((isAllParkedState || localStorage.getItem("dineIn") === "N") && (!matchedRep || tillaccess?.waiterPayment === "Y")) {
      return (
        <Row style={{ padding: "0 5px 0 0 " }}>
          {posConfig?.enableAdditionalCharges === "Y" && (
            <Col
              // span={posConfig?.enableAdditionalCharges === "Y" && posConfig?.enableSplitBill === "Y" ? 8 : 24}
              span={Math.floor(
                24 / ((posConfig?.enableAdditionalCharges === "Y" ? 1 : 0) + (localStorage.getItem("dineIn") === "Y" ? 1 : 0) + (posConfig?.enableSplitBill === "Y" ? 1 : 0))
              )}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                padding: "1.5vh 0 0 0.5vw",
              }}
            >
              <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em", fontWeight: 500 }}>Additional Charges</p>
              <PlusOutlined
                style={{
                  cursor: "pointer",
                  paddingLeft: "1vw",
                }}
                onClick={handleAdditionalCharges}
              />
            </Col>
          )}

          {renderPrepareBill()}
          {posConfig?.enableSplitBill === "Y" && (
            <Col
              // span={posConfig?.enableAdditionalCharges === "Y" && posConfig?.enableSplitBill === "Y" ? 8 : 24}
              span={Math.floor(
                24 / ((posConfig?.enableAdditionalCharges === "Y" ? 1 : 0) + (localStorage.getItem("dineIn") === "Y" ? 1 : 0) + (posConfig?.enableSplitBill === "Y" ? 1 : 0))
              )}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "1vh 0 0 0.5vw",
                justifyContent: "right",
              }}
            >
              <Button
                style={{
                  width: "100%",
                  border: "1px solid rgba(146, 144, 152, 0.5)",
                  borderRadius: "10px",
                  color: "#2F3856",
                  height: "5.5vh",
                  fontSize: "1em",
                  fontWeight: "500",
                }}
                onClick={() => {
                  setShowSplitBill(true);
                }}
              >
                <TeamOutlined />
                Split Bill
              </Button>
            </Col>
          )}
        </Row>
      );
    }
  };

  const renderHoldOrderDiscountButtons = () => {
    if ((isAllParkedState || localStorage.getItem("dineIn") === "N") && (!matchedRep || tillaccess?.waiterPayment === "Y")) {
      return (
        <div>
          <Space direction="horizontal" style={{ paddingTop: "2vh", fontSize: "1vw" }}>
            <Button
              style={{
                width: "13.5vw",
                borderRadius: "10px",
                color: "#2F3856",
                height: "5.5vh",
                fontSize: "1em",
                fontWeight: "500",
              }}
              onClick={() => {
                openDisplayParkedBillModal();
              }}
            >
              <img src={printBill} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
              <span>Hold Order</span>
            </Button>
            {tillData?.tillAccess?.manualDiscount === "Y" && (
              <Button
                style={{
                  width: "13.5vw",
                  border: "1px solid rgba(146, 144, 152, 0.5)",
                  borderRadius: "10px",
                  color: "#2F3856",
                  height: "5.5vh",
                  fontSize: "1em",
                  fontWeight: "500",
                  marginLeft: "0.3em",
                }}
                onClick={manualDiscountRestaurant}
              >
                <img src={DiscountIcon} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
                <span>Add Discount</span>
              </Button>
            )}
          </Space>
        </div>
      );
    }
  };
  return (
    <>
      {paymentVisible ? (
        <OrderListComponent
          {...props}
          requestPayment={requestPayment}
          recordState={recordState}
          setRecardState={setRecardState}
          setSearchhistoryInput={setSearchhistoryInput}
          searchHistoryInput={searchHistoryInput}
          setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
          productCategoriesList={productCategoriesList}
          setProductCategoriesList={setProductCategoriesList}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          bestsellerCategories={bestsellerCategories}
          handleCategoryClick={handleCategoryClick}
          saleTypeProducts={saleTypeProducts}
          setSaleTypeProducts={setSaleTypeProducts}
          setMainTableData={setMainTableData}
          mainTableData={mainTableData}
          restaurantButtonLoading={restaurantButtonLoading}
          setRestaurantButtonLoading={setRestaurantButtonLoading}
        />
      ) : splitBillScreen ? (
        <div style={{ padding: "10px 0px 10px 15px", fontSize: "1vw", overflow: "hidden" }}>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <img
              src={Back}
              style={{
                height: "4vh",
                cursor: "pointer",
                paddingBottom: "0.1em",
              }}
              onClick={() => {
                const unpaidSplits = splitCarts.length;
                const paidSplits = numSplits - unpaidSplits;

                if (paidSplits > 0 && unpaidSplits > 0) {
                  message.warning("Please complete payment for remaining splits");
                  return;
                }
                setCategorySplitSelection({});
                setItemSplitMap({});
                setSplitBillScreen(false);
                setNumSplits(2);
                setIsSplitBill(false);
                setSplitCarts([]);
                setCurrentSplitIndex(0);
                setShowAllItems(true);
              }}
            />
            <p style={{ marginBottom: 0, paddingLeft: "4px", color: "#0F0718", fontSize: "1.5em", fontWeight: 500 }}>Split Bill</p>
          </Row>
          <Row style={{ marginTop: "2vh" }}>
            {showAllItems ? (
              <Col span={6} style={{ border: "1px solid #ccc", height: "83vh", borderRadius: "7px", backgroundColor: "#fff" }}>
                <p style={{ marginBottom: 0, fontSize: "1.25em", fontWeight: 500, color: "#0F0718", textAlign: "left", padding: "10px 10px 0 20px" }}>All Items </p>
                <p style={{ marginBottom: 0, fontSize: "0.8em", fontWeight: 300, color: "#929098", textAlign: "left", padding: "0 10px 0 20px" }}>
                  Assign entire categories or individual items to splits
                </p>

                <Scrollbars autoHide style={{ height: "75vh", marginTop: "1vh" }}>
                  <div style={{ padding: "0px 15px 10px 15px" }}>
                    {groupedItems.map((group, gIndex) => (
                      <div
                        key={gIndex}
                        style={{
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          marginBottom: "15px",
                          background: "transparent",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid #E0E0E0",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          {/* HEADER */}
                          <div
                            style={{
                              padding: "10px 10px",
                              cursor: "pointer",
                            }}
                            onClick={() => toggleCategory(gIndex)}
                          >
                            {/* HEADER CLICK ROW */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <p style={{ marginBottom: 0, fontWeight: 600, fontSize: "1em", color: "#0F0718" }}>{group.category}</p>

                                <p
                                  style={{
                                    fontSize: "0.9em",
                                    color: "#929098",
                                    margin: "0 0 0 0",
                                  }}
                                >
                                  {group.items.length} items · {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {group.items.reduce((s, i) => s + i.nettotal, 0).toFixed(2)}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                </p>
                              </div>

                              <span style={{ fontSize: "12px", color: "#2F3856", paddingRight: "0.5vw" }}>{openCategory === gIndex ? <UpOutlined /> : <DownOutlined />}</span>
                            </div>

                            <div style={{ marginTop: "2px" }}>
                              <p
                                style={{
                                  marginBottom: "6px",
                                  fontSize: "0.8em",
                                  color: "#929098",
                                }}
                              >
                                Quick assign entire category:
                              </p>
                              <div style={{ display: "flex", gap: "8px" }}>
                                {[...Array(numSplits)].map((_, idx) => {
                                  const isSelected = categorySplitSelection[group.category] === idx;

                                  return (
                                    <button
                                      key={idx}
                                      style={{
                                        background: isSelected ? "#fff" : "#2F3856",
                                        color: isSelected ? "#2F3856" : "#fff",
                                        border: "1px solid #2F3856",
                                        borderRadius: "20px",
                                        padding: "2.5px 10px",
                                        fontSize: "0.8em",
                                        cursor: "pointer",
                                        textAlign: "center",
                                      }}
                                      // onClick={() => {
                                      //   assignWholeCategory(group, idx);

                                      //   setCategorySplitSelection((prev) => {
                                      //     if (prev[group.category] === idx) {
                                      //       return {
                                      //         ...prev,
                                      //         [group.category]: undefined,
                                      //       };
                                      //     }
                                      //     return {
                                      //       ...prev,
                                      //       [group.category]: idx,
                                      //     };
                                      //   });
                                      // }}
                                      onClick={() => {
                                        const undo = categorySplitSelection[group.category] === idx;

                                        assignWholeCategory(group, idx, undo);

                                        setCategorySplitSelection((prev) => (undo ? { ...prev, [group.category]: undefined } : { ...prev, [group.category]: idx }));
                                      }}
                                    >
                                      Split {idx + 1}
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* WHEN CATEGORY EXPANDED */}
                        {openCategory === gIndex && (
                          <>
                            {group.items.map((item, index) => (
                              <div
                                key={index}
                                style={{
                                  border: "1px solid #E0E0E0",
                                  margin: "10px 14px",
                                  borderRadius: "6px",
                                  padding: "12px",
                                  background: "#fff",
                                }}
                              >
                                <Row>
                                  <Col span={18} style={{ fontWeight: 600, color: "#0F0718", fontSize: "1em" }}>
                                    {item?.productAliasName ? item?.productAliasName : item.name}
                                  </Col>

                                  <Col span={6} style={{ textAlign: "right", fontWeight: 600, marginBottom: 0 }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {item.nettotal}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Col>

                                  <Col span={24}>
                                    <p style={{ marginBottom: 0, fontSize: "0.9em", color: "#929098" }}>Quantity: {item.weight}</p>

                                    <p
                                      style={{
                                        marginBottom: 4,
                                        marginTop: "0.5vh",
                                        fontWeight: 500,
                                        fontSize: "0.8em",
                                        color: "#929098",
                                      }}
                                    >
                                      Assign to splits:
                                    </p>

                                    <div style={{ display: "flex", gap: "8px" }}>
                                      {[...Array(numSplits)].map((_, i) => {
                                        const isOn = itemSplitMap[item.lineId]?.[i] ?? true;
                                        return (
                                          <button
                                            key={i}
                                            onClick={() => handleToggleItemSplit(item, i)}
                                            style={{
                                              backgroundColor: isOn ? "#2F3856" : "#fff",
                                              color: isOn ? "#fff" : "#2F3856",
                                              border: "1px solid #2F3856",
                                              borderRadius: "20px",
                                              padding: "2.5px 10px",
                                              fontSize: "0.8em",
                                              cursor: "pointer",
                                            }}
                                          >
                                            Split {i + 1}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </Scrollbars>
              </Col>
            ) : null}

            <Col span={18} style={{ padding: "0 15px" }}>
              <Row gutter={[8, 8]}>
                {/* {[...Array(numSplits)].map((_, splitIndex) => {
                  const splitCart = splitCarts[splitIndex] || {}; */}
                {splitCarts.map((splitCart, splitIndex) => {
                  return (
                    <Col span={8} key={splitIndex}>
                      <div
                        style={{
                          background: "#fff",
                          height: "83vh",
                          width: "100%",
                          position: "relative",
                          fontSize: "1vw",
                          borderRadius: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "2vh 1vw 0 1vw",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: 600,
                              fontSize: "1.5em",
                              color: "#0F0718",
                              fontFamily: "Inter",
                            }}
                          >
                            {getMultilingualText("Order Details")}
                          </span>
                          <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>{moment(splitCart.orderTime).format(userPreferences.dateFormat)}</span>
                        </div>

                        {/* {saleType === "DI" && (
                          <p
                            style={{
                              padding: "0 1vw",
                              fontSize: "1em",
                              color: "#0F0718",
                              fontWeight: 500,
                              marginBottom: "5px",
                            }}
                          >
                            {selectedTable?.name}
                          </p>
                        )}

                        <span>Split {splitCart.splitNo}</span> */}

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0.5vh 1vw 0 1vw",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "0.9em",
                              color: "#0F0718",
                              fontWeight: 500,
                            }}
                          >
                            {/* {selectedTable?.name} */}
                            {localStorage.getItem("dineIn") === "Y" && splitCart?.tableNo && splitCart.tableNo} {splitCart?.documentno}
                            {/* {splitCart?.tableNo} {splitCart?.documentno} */}
                          </span>
                          <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>Split {splitCart.splitNo}</span>
                        </div>

                        <hr style={{ color: "#929098", width: "93%" }} />

                        <Scrollbars
                          autoHide
                          style={{
                            height: !showAllItems ? "41vh" : "50vh",
                          }}
                        >
                          <InfiniteScroll
                            dataLength={splitCart.items?.length || 0}
                            hasMore={true}
                            endMessage={
                              <p className="center">
                                <b>Yay! you have seen it all</b>
                              </p>
                            }
                            style={{ overflowX: "hidden" }}
                          >
                            {splitCart.items?.map((item) => (
                              <div key={item.lineId} style={{ padding: "12px" }}>
                                <div
                                  style={{
                                    fontSize: "1vw",
                                    backgroundColor: selectedProductId === item.lineId ? "#f0f0f0" : "transparent",
                                  }}
                                >
                                  <Row>
                                    <Col span={5}>
                                      <img
                                        src={item.imageurl || defaultImage}
                                        alt={item?.productAliasName ? item?.productAliasName : item.name}
                                        style={{
                                          height: item.description ? "10vh" : "8vh",
                                          width: "4vw",
                                          objectFit: "cover",
                                          borderRadius: "7px",
                                        }}
                                      />
                                    </Col>
                                    <Col span={16} style={{ display: "flex", flexDirection: "column", paddingLeft: "0.5vw" }}>
                                      <Text style={{ fontSize: "0.8em", color: "#0F0718", fontWeight: 500 }}>{item?.productAliasName ? item?.productAliasName : item.name}</Text>
                                      <Text style={{ fontSize: "0.5em", color: "#929098", fontWeight: 400 }}>{item.description}</Text>
                                      <Text style={{ fontWeight: 600, fontSize: "1em", color: "#0F0718" }}>
                                        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                        {/* {item.nettotal.toFixed(item?.isQtyDesimal)} */}
                                        {toFixedTruncate(item.nettotal, item?.isQtyDesimal)}
                                        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                      </Text>
                                    </Col>
                                    <Col
                                      span={2}
                                      style={{
                                        textAlign: "center",
                                        color: "#0F0718",
                                        fontWeight: 500,
                                        fontSize: "0.8em",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      X {item.weight}
                                    </Col>
                                    <span
                                      style={{
                                        background: Math.abs(item.discount) > 0 ? "#F8C519" : "",
                                        borderRadius: "3px",
                                        padding: "0.25vw",
                                        display: item.discountName ? "" : "none",
                                        fontSize: "0.7em",
                                        marginTop: "1vh",
                                      }}
                                    >
                                      {Math.abs(item.discount) > 0 && item.discountName && (
                                        <>
                                          <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> {item.discountName}
                                        </>
                                      )}
                                    </span>
                                  </Row>
                                </div>
                              </div>
                            ))}
                          </InfiniteScroll>
                        </Scrollbars>

                        <div
                          style={{
                            padding: "1vh 0.6vw",
                            position: "absolute",
                            bottom: "1vh",
                            width: "100%",
                          }}
                        >
                          <Scrollbars autoHide style={{ height: "18vh" }}>
                            <Space
                              direction="vertical"
                              style={{
                                width: "100%",
                                background: "#F3F4F9",
                                padding: "1vh 0.5vw",
                                borderRadius: "10px",
                                rowGap: "4px",
                              }}
                            >
                              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Subtotal")}</Text>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {/* {(splitCart?.total - splitCart?.tax).toFixed(2)} */}
                                  {toFixedTruncate(splitCart?.total - splitCart?.tax, pricePrecision)}
                                  {/* {toFixedTruncate(splitCart?.subTotal, pricePrecision)} */}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </Text>
                              </Space>

                              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Discount Sales")}</Text>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {/* {parseFloat(splitCart?.discount || 0).toFixed(2)} */}
                                  {toFixedTruncate(splitCart?.discount || 0, pricePrecision)}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </Text>
                              </Space>

                              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Total Sales Tax")}</Text>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {/* {parseFloat(splitCart.tax).toFixed(2)} */}
                                  {toFixedTruncate(splitCart.tax, pricePrecision)}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </Text>
                              </Space>

                              {serviceChargeAmount > 0 && (
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Service Charge")}</Text>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(Math.floor(parseFloat(splitCart.serviceCharge || 0) * 100) / 100, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>
                                </Space>
                              )}
                              {tipTotal > 0 && (
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Tip")}</Text>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(Math.floor(parseFloat(splitCart.tip || 0) * 100) / 100, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>
                                </Space>
                              )}
                              {deliveryCharge > 0 && (
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Delivery Charge")}</Text>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(Math.floor(parseFloat(splitCart.deiveryCharge || 0) * 100) / 100, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>
                                </Space>
                              )}
                              {packingCharge > 0 && (
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Packing Charge")}</Text>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(Math.floor(parseFloat(splitCart.packingCharge || 0) * 100) / 100, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>
                                </Space>
                              )}

                              <Space style={{ width: "100%", justifyContent: "space-between", marginTop: "2px" }}>
                                <Text style={{ fontSize: "1em", fontWeight: 600, color: "#0F0718", fontFamily: "Inter" }}>{getMultilingualText("Total Amount")}</Text>
                                <Text style={{ fontSize: "1em", fontWeight: 600, color: "#0F0718", fontFamily: "Inter" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {toFixedTruncate(
                                    Math.floor(
                                      parseFloat(
                                        splitCart.total + (splitCart.deiveryCharge || 0) + (splitCart.packingCharge || 0) + (splitCart.tip || 0) + (splitCart.serviceCharge || 0)
                                      ) * 100
                                    ) / 100,
                                    pricePrecision
                                  )}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </Text>
                              </Space>
                            </Space>
                          </Scrollbars>
                          {!showAllItems && (
                            <div>
                              <Space direction="horizontal" style={{ paddingTop: "2vh" }}>
                                <Button
                                  onClick={() => {
                                    // setSplitBillScreen(false);
                                    setPaymentVisible(true);
                                    // setAmount((Math.floor(parseFloat(splitCart.total || 0) * 100) / 100).toFixed(2));
                                    setRemoveSplit(splitCart);
                                    setAmount(toFixedTruncate(Math.floor(parseFloat(splitCart.total || 0) * 100) / 100, pricePrecision));
                                    setCart(splitCart);

                                    localStorage.setItem("cartObj", JSON.stringify(splitCart));
                                    const tablename = JSON.parse(localStorage.getItem("tableName"));

                                    const newSplitCartData = {
                                      ...recordState,
                                      documentno: splitCart.documentno,
                                      items: splitCart.items,
                                      uniqueId: uuidv4().replace(/-/g, "").toUpperCase(),
                                    };
                                    localStorage.setItem("tableName", JSON.stringify(newSplitCartData));
                                  }}
                                  style={{
                                    width: "21vw",
                                    borderRadius: "10px",
                                    backgroundColor: "#2F3856",
                                    color: "#fff",
                                    height: "6vh",
                                    fontSize: "1em",
                                    fontWeight: 500,
                                  }}
                                >
                                  Pay Bill
                                </Button>
                              </Space>
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  );
                })}
                {/* })} */}
              </Row>
            </Col>
          </Row>
          {showAllItems ? (
            <Row style={{ marginTop: "1.3vh", display: "flex", justifyContent: "flex-end", padding: "0px 15px 0px 0px" }}>
              <Col span={4}>
                <Button
                  style={{
                    backgroundColor: "#2F3856",
                    color: "#fff",
                    fontSize: "1.2em",
                    borderRadius: "5px",
                    width: "100%",
                    height: "5.5vh",
                  }}
                  onClick={() => {
                    setShowAllItems(false);
                    const cartobj = JSON.parse(localStorage.getItem("cartObj"));
                    const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
                    const newDocumentSequence = tillDocumentSequence;
                    localStorage.setItem("documentSequence", newDocumentSequence);
                    // setDocumnetSequence(newDocumentSequence);
                  }}
                >
                  Done
                </Button>
              </Col>
            </Row>
          ) : null}
        </div>
      ) : (
        <div style={{ display: "flex", overflow: "hidden" }}>
          <div style={{ width: cart.items.length > 0 ? "69%" : "100%", height: "100vh" }}>
            <Row
              style={{
                padding: "0vh 2.5vw 0 1.5vw",
                fontSize: "1vw",
                alignItems: "center", // ← helps vertical alignment
              }}
            >
              <Col span={24}>
                <p
                  style={{
                    fontWeight: 500,
                    paddingLeft: "3px",
                    fontSize: "1.25em",
                    color: "#0F0718",
                    paddingTop: "0.5em",
                    margin: 0,
                  }}
                >
                  {posConfig?.disableOfflineBilling !== "Y" && (
                    <>
                      {getMultilingualText("Order")}: {JSON.parse(localStorage.getItem("cartObj"))?.documentno}
                    </>
                  )}
                </p>
              </Col>

              {/* Search row with back button on the left when visible */}
              <Col span={24}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px", // space between back + search
                    flexWrap: "nowrap",
                  }}
                >
                  {showProducts && (
                    <img
                      src={Back}
                      style={{
                        height: "4.5vh",
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                      onClick={() => {
                        setShowProducts(false);
                        setShowSendToKitchen(false);
                      }}
                      alt="back"
                    />
                  )}

                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      minWidth: 0, // prevents overflow issues
                    }}
                  >
                    <Input
                      placeholder={getMultilingualText("Search for products by code/name")}
                      id="sm-product-search"
                      onChange={(e) => setProductSearchInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "+" || e.key === "=") {
                          e.preventDefault();
                          e.stopPropagation();
                        }
                        if (e.key === "-" && e.target.selectionStart === 0) {
                          e.preventDefault();
                        }
                      }}
                      className="productSearch-sm"
                      style={{
                        borderRadius: "20px",
                        padding: "0.8vh 0.8vw",
                        borderColor: "#fff",
                        flex: 1,
                      }}
                      value={productSearchInput}
                      suffix={
                        productSearchInput.length > 0 ? (
                          <CloseSquareFilled style={{ fontSize: "20px", color: "#2F3856", cursor: "pointer" }} onClick={() => setProductSearchInput("")} />
                        ) : null
                      }
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="search"
                          onClick={() => {
                            // onBarcodeInput(productSearchInput, false);
                          }}
                        />
                      }
                    />

                    <Button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "4.5%",
                        margin: "0 1vw 0 0.5vw",
                        borderRadius: "7px",
                        borderColor: "#fff",
                        flexShrink: 0,
                      }}
                      id="sm-product-drawer"
                      onClick={() => {
                        setFilterDrawer(true);
                        setTimeout(() => {
                          if (productPanelSearchRef.current) {
                            productPanelSearchRef.current.focus();
                          }
                        }, 100);
                      }}
                    >
                      <img src={FilterIcon} style={{ height: "2.7vh" }} alt="filter" />
                    </Button>
                  </div>

                  {/* Parked Orders button stays on the right */}
                  {localStorage.getItem("dineIn")
                    ? localStorage.getItem("dineIn") !== "Y" && (
                        <Badge
                          count={JSON.parse(localStorage.getItem("parkedList") || "[]").length}
                          overflowCount={99}
                          style={{
                            backgroundColor: "#FF8A00",
                            color: "#fff",
                            fontSize: "11px",
                            fontWeight: 600,
                            minWidth: "18px",
                            height: "18px",
                            lineHeight: "18px",
                            borderRadius: "7px",
                            boxShadow: "0 0 0 2px #fff",
                          }}
                          size="small"
                          offset={[-5, 5]}
                        >
                          <Button
                            onClick={() => {
                              const parkedList = JSON.parse(localStorage.getItem("parkedList") || "[]");
                              const mappedList = parkedList.map((record, index) => ({
                                ...record,
                                status: "Parked",
                                key: uuidv4().replace(/-/g, "").toUpperCase(),
                                customer: record?.parkedCart?.customer?.name || "",
                                qty: record?.parkedCart?.totalQty || 0,
                              }));
                              localStorage.setItem("parkedList", JSON.stringify(mappedList));
                              setFilterdParkedList(mappedList);
                              setParkedDrawerOpen(true);
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              borderRadius: "7px",
                              borderColor: "#fff",
                              padding: "6px 14px",
                              background: "#FFFFFF",
                            }}
                          >
                            <CodeSandboxOutlined style={{ fontSize: "18px", color: "#0F0718" }} />
                            <span style={{ fontSize: "0.8rem", color: "#0F0718", fontWeight: 500 }}>Parked Orders</span>
                          </Button>
                        </Badge>
                      )
                    : null}
                </div>
              </Col>
            </Row>
            <div className="tables-container-category" style={{ display: "flex" }}>
              {/* Left side: Categories */}
              <div
                style={{
                  width: "18%",
                  background: "#fff",
                  borderRight: "1px solid #eee",
                  padding: "1vh 0.5vw",
                  height: "87vh",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Search bar for categories */}
                <Input
                  placeholder="Search by categories"
                  value={categorySearch}
                  onChange={(e) => setCategorySearch(e.target.value)}
                  style={{ marginBottom: "1vh", borderRadius: "6px" }}
                />

                {/* Category list */}
                <Scrollbars autoHide style={{ flex: 1 }}>
                  {(bestsellerCategories.length > 0 ? bestsellerCategories : productCategoriesList)
                    .filter((categorie) => categorie.name.toLowerCase().includes(categorySearch.toLowerCase()))
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((categorie) => {
                      const isSelected = selectedCategory === categorie.mProductCategoryId;
                      return (
                        <div
                          key={categorie.mProductCategoryId}
                          onClick={() => handleCategoryClick(categorie.mProductCategoryId, categorie.name)}
                          style={{
                            padding: "6px 10px",
                            cursor: loading ? "not-allowed" : "pointer",
                            background: isSelected ? "#F5F6FA" : "transparent",
                            color: isSelected ? "#000" : "#555",
                            fontWeight: isSelected ? "600" : "400",
                            borderLeft: isSelected ? "4px solid #2F3856" : "4px solid transparent",
                          }}
                        >
                          {categorie.name}
                        </div>
                      );
                    })}
                </Scrollbars>
              </div>

              {/* Right side: Products (UNCHANGED from your code) */}
              <div style={{ flex: 1 }}>
                <Scrollbars autoHide style={{ height: "87vh" }}>
                  <InfiniteScroll
                    dataLength={bestsellerCategories.length} // SAME AS ORIGINAL
                    hasMore={true}
                    endMessage={
                      <p style={{ textAlign: "center" }}>
                        <b>Yay! you have seen it all</b>
                      </p>
                    }
                    style={{ overflowX: "hidden" }}
                  >
                    {loading ? (
                      <p style={{ textAlign: "center" }}>Loading products...</p>
                    ) : (
                      <Row gutter={[10, 10]} style={{ marginLeft: "0.5vw", padding: "0 10px" }}>
                        {(() => {
                          // ---------------------------------------------------------
                          // SAFELY COMPUTE productsToShow (EXACT LOGIC FROM REFERENCE)
                          // ---------------------------------------------------------
                          const productsToShow =
                            productSearchInput.length > 0
                              ? bestsellerCategories.length > 0
                                ? filteredProducts
                                : saleTypeProducts.filter((product) => {
                                    const searchInput = productSearchInput.toLowerCase();
                                    const matchesName = product.name?.toLowerCase().includes(searchInput);
                                    const matchesValue = product.value?.toLowerCase().includes(searchInput);
                                    const matchesUPC = product.upc?.toLowerCase().includes(searchInput);
                                    const matchesAlias = product?.productAliasName?.toLowerCase().includes(searchInput);
                                    return matchesName || matchesValue || matchesUPC || matchesAlias;
                                  })
                              : bestsellerCategories.length > 0 && filteredProducts.length > 0
                                ? filteredProducts
                                : saleTypeProducts.filter((product) => product.mProductCategoryId === selectedCategory);

                          const safeProducts = Array.isArray(productsToShow) ? productsToShow : [];

                          const cardSpan = cart.items.length > 0 ? 6 : 4;

                          return safeProducts.map((product) => {
                            const productKey = product.mProductId || product.id || crypto.randomUUID();

                            return (
                              <Col key={productKey} span={cardSpan}>
                                <Card
                                  onClick={(e) => {
                                    // if (product?.productAddons?.length > 0 && product?.showAddons === "Y") {
                                    //   // Get all cart lines for this product that have addons
                                    //   const productAddonLines = cart.items.filter(
                                    //     (item) => item.productId === product.productId && !item.isReturn && item.selectedAddons?.length > 0
                                    //   );

                                    //   if (productAddonLines.length > 0) {
                                    //     if (productAddonLines.length === 1) {
                                    //       setAddonSourceItem(productAddonLines[0]);
                                    //       setAddonRepeatDisabled(false);
                                    //     } else {
                                    //       setAddonSourceItem(null);
                                    //       setAddonRepeatDisabled(true);
                                    //     }

                                    //     setShowAddonsCustomizePopUp(true);
                                    //   } else {
                                    //     // First time adding product with addons
                                    //     handleAddOnModal(product, e);
                                    //   }
                                    // } else {
                                    //   // No addons → normal add
                                    //   pickProduct(product);
                                    // }
                                    setSelectedProduct(product);
                                    if (product?.productAddons?.length > 0 && product?.showAddons === "Y") {
                                      const productAddonLines = cart.items.filter(
                                        (item) => item.mProductId === product.mProductId && !item.isReturn && item.selectedAddons?.length > 0
                                      );
                                      if (productAddonLines.length > 0) {
                                        const requiredListFilter = _.filter(product.productAddons || [], (item) => item.mAddonGroup.minqty === 1);

                                        const optionsListFilter = _.filter(product.productAddons || [], (item) => item.mAddonGroup.minqty === 0);

                                        setAddOnsList({
                                          requiredList: requiredListFilter,
                                          optionsList: optionsListFilter,
                                        });
                                        const existingAddonSignatures = productAddonLines.map((line) => getAddonSignature(line.selectedAddons));
                                        const allSameAddons = existingAddonSignatures.every((sig) => sig === existingAddonSignatures[0]);
                                        if (allSameAddons) {
                                          setAddonSourceItem(productAddonLines[0]);
                                          setAddonRepeatDisabled(false);
                                        } else {
                                          setAddonSourceItem(productAddonLines[0]);
                                          setAddonRepeatDisabled(true);
                                        }
                                        const firstLine = productAddonLines[0];
                                        if (firstLine?.order === "Y") {
                                          handleAddOnModal(product, e);
                                        } else {
                                          setShowAddonsCustomizePopUp(true);
                                        }
                                      } else {
                                        handleAddOnModal(product, e);
                                      }
                                    } else {
                                      pickProduct(product);
                                    }
                                  }}
                                  // onClick={(e) =>
                                  //   product?.productAddons?.length > 0 && product?.showAddons === "Y"
                                  //     ? handleAddOnModal(product, e) // KEEP event parameter
                                  //     : pickProduct(product)
                                  // }
                                  style={
                                    showImage
                                      ? {
                                          borderRadius: "8px",
                                          border: "1px solid #e8e8e8",
                                          cursor: "pointer",
                                          position: "relative",
                                          padding: "12px",
                                          overflow: "visible",
                                        }
                                      : {
                                          height: "75px",
                                          borderRadius: "10px",
                                          border: "1px solid #e8e8e8",
                                          padding: "10px",
                                          cursor: "pointer",
                                          color: "#0F0718",
                                          fontWeight: "500",
                                          backgroundColor: getColorFromId(product.mProductId || product.id),
                                          overflow: "hidden",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "flex-start",
                                          position: "relative",
                                        }
                                  }
                                >
                                  {showImage ? (
                                    <>
                                      {/* IMAGE BOX */}
                                      <div
                                        style={{
                                          height: "60px",
                                          background: "#f5f5f5",
                                          borderRadius: "6px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          marginBottom: "8px",
                                          overflow: "hidden",
                                          position: "relative",
                                        }}
                                      >
                                        <img
                                          src={product.imageurl || defaultImage}
                                          alt={product?.productAliasName ? product?.productAliasName : product.name}
                                          style={{
                                            width: product.imageurl ? "100%" : "40px",
                                            height: product.imageurl ? "100%" : "40px",
                                            objectFit: product.imageurl ? "cover" : "contain",
                                            margin: product.imageurl ? 0 : "auto",
                                          }}
                                        />

                                        {product.isBestSeller && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "4px",
                                              right: "4px",
                                              backgroundColor: "#eab308",
                                              padding: "2px 6px",
                                              display: "flex",
                                              alignItems: "center",
                                              borderRadius: "10px",
                                              fontSize: "10px",
                                              fontWeight: 500,
                                              zIndex: 2,
                                            }}
                                          >
                                            <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
                                            Best
                                          </div>
                                        )}
                                      </div>

                                      {/* TEXT SECTION */}
                                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                        <h3
                                          title={product?.productAliasName ? product?.productAliasName : product.name}
                                          style={{
                                            fontSize: "0.9em",
                                            fontWeight: 600,
                                            color: "#0F0718",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                            display: "-webkit-box",
                                            minHeight: "38px",
                                            margin: 0,
                                          }}
                                        >
                                          {product?.productAliasName ? product?.productAliasName : product.name}
                                        </h3>

                                        {product.value && (
                                          <div style={{ fontSize: "0.8rem", color: "#4b5563", marginBottom: "0.25rem" }}>
                                            <span style={{ fontWeight: 500 }}>{product.value}</span>
                                          </div>
                                        )}

                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                          <span
                                            style={{
                                              fontSize: "1em",
                                              fontWeight: 600,
                                              color: "#389e0d",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "2px",
                                              maxWidth: "100%",
                                            }}
                                          >
                                            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                            {product.sunitprice.toFixed(2)}
                                            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}

                                            {product.uomName && (
                                              <span
                                                title={product.uomName}
                                                style={{
                                                  maxWidth: "55px",
                                                  whiteSpace: "nowrap",
                                                  color: "#389e0d",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  fontWeight: 600,
                                                  fontSize: "1em",
                                                }}
                                              >
                                                /{product.uomName}
                                              </span>
                                            )}
                                          </span>

                                          {getFoodTypeIcon(product.foodType) && <img src={getFoodTypeIcon(product.foodType)} style={{ height: "18px" }} alt="food type" />}
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {/* MINIMAL CARD */}
                                      <p
                                        title={product?.productAliasName ? product?.productAliasName : product.name}
                                        style={{
                                          fontWeight: 500,
                                          fontSize: "13px",
                                          margin: 0,
                                          lineHeight: "1.4",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "100%",
                                          padding: "0 4px",
                                        }}
                                      >
                                        {product?.productAliasName ? product?.productAliasName : product.name}
                                      </p>

                                      <p
                                        style={{
                                          color: "#6B7280",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          margin: 0,
                                          position: "absolute",
                                          bottom: "8px",
                                          left: "10px",
                                        }}
                                      >
                                        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                        {product.sunitprice.toFixed(2)}
                                        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                      </p>
                                    </>
                                  )}
                                </Card>
                              </Col>
                            );
                          });
                        })()}
                      </Row>
                    )}
                  </InfiniteScroll>
                </Scrollbars>
              </div>
            </div>
            {/* <div className="tables-container-category">
  <Scrollbars autoHide style={{ height: "76vh" }}>
    <InfiniteScroll
      dataLength={productCategoriesList.length}
      hasMore={true}
      endMessage={
        <p className="center">
          <b>Yay! you have seen it all</b>
        </p>
      }
      style={{ overflowX: "hidden" }}
    >
      <Row gutter={[16, 16]} style={{ marginTop: "1vh" }}>
        {productCategoriesList
          .filter((categorie) => (productSearchInput.length === 0 ? true : categorie.name.toLowerCase().includes(productSearchInput.toLowerCase())))
          .map((categorie) => (
            <Col
              key={categorie.mProductCategoryId}
              style={{ display: "flex", justifyContent: "center", paddingRight: 0 }}
            >
              <Card
                onClick={() => {
                  setSelectedCategory(categorie.mProductCategoryId);
                  setCategorieName(categorie.name);
                  restaurantProductCategory(categorie.mProductCategoryId);
                  setCategorieFlag(true);
                  setProductSearchInput("");
                }}
                style={{
                  background: selectedCategory === categorie.mProductCategoryId ? "#2F3856" : "#fff",
                  height: "6vh",
                  borderRadius: "25px",
                  fontSize: "1vw",
                  cursor: "pointer",
                  display: "inline-block",
                  padding: "0 1em",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    fontSize: "1.1em",
                    fontWeight: "500",
                    color: selectedCategory === categorie.mProductCategoryId ? "#fff" : "#929098",
                  }}
                >
                  {categorie.name}
                </span>
              </Card>
            </Col>
          ))}
      </Row>

      {productSearchInput.length > 0 ? (
        // Search results grouped by category
        Object.entries(
          saleTypeProducts
            .filter((product) => {
              const searchInput = productSearchInput.toLowerCase();
              const matchesName = product.name?.toLowerCase().includes(searchInput);
              const matchesValue = product.value?.toLowerCase().includes(searchInput);
              const matchesUPC = product.upc?.toLowerCase().includes(searchInput);
              return matchesName || matchesValue || matchesUPC;
            })
            .reduce((acc, product) => {
              const categoryId = product.mProductCategoryId.trim();
              const categoryName = categoryLookup[categoryId] || "Unknown Category";
              if (!acc[categoryName]) {
                acc[categoryName] = [];
              }
              acc[categoryName].push(product);
              return acc;
            }, {})
        ).map(([categoryName, products]) => (
          <div key={categoryName} style={{ marginTop: "3vh" }}>
            <Text style={{ fontSize: "1.2em", fontWeight: "500", color: "#0F0718", paddingLeft: "1.5vw" }}>{categoryName}</Text>
            <Row gutter={[16, 16]} style={{ marginTop: "1vh" }}>
              {products.map((product) => (
                <Col span={cart.items.length > 0 ? 6 : 4} key={product.id} onClick={() => {}}>
                  <Card
                    onClick={product?.productAddons?.length > 0 ? (e) => handleAddOnModal(product, e) : () => pickProduct(product)}
                    style={{
                      height: "28vh",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={product?.imageurl?.trim() || defaultImage}
                      style={{
                        height: "17vh",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        borderRadius: "10px",
                        padding: "0.8vh 0.55vw",
                        width: "100%",
                      }}
                    />
                    <div
                      style={{
                        height: "7vh",
                        paddingLeft: "0.8vw",
                        fontWeight: 500,
                        fontSize: "1vw",
                        paddingRight: "0.8vw",
                      }}
                    >
                      <p
                        style={{
                          margin: "0",
                          fontSize: "1em",
                          fontWeight: 500,
                          color: "#0F0718",
                          height: "6vh",
                        }}
                      >
                        {product?.name}
                      </p>
                      <Row>
                        <Col
                          span={21}
                          style={{
                            fontSize: "1.25em",
                            fontWeight: "600",
                            color: "#0F0718",
                          }}
                        >
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {product?.sunitprice}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Col>
                        <Col
                          span={2}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "2px",
                          }}
                        >
                          <img src={removeBg} style={{ height: "1.8vh" }} />
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ))
      ) : (
        // Non-search: Current category products
        <Row gutter={[16, 16]} style={{ marginTop: "3vh" }}>
          {productsData.map((product) => (
            <Col span={cart.items.length > 0 ? 6 : 4} key={product.id} onClick={() => {}}>
              <Card
                onClick={product?.productAddons?.length > 0 ? (e) => handleAddOnModal(product, e) : () => pickProduct(product)}
                style={{
                  height: "28vh",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                <img
                  src={product?.imageurl?.trim() || defaultImage}
                  style={{
                    height: "17vh",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    borderRadius: "10px",
                    padding: "0.8vh 0.55vw",
                    width: "100%",
                  }}
                />
                <div
                  style={{
                    height: "7vh",
                    paddingLeft: "0.8vw",
                    fontWeight: 500,
                    fontSize: "1vw",
                    paddingRight: "0.8vw",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      fontSize: "1em",
                      fontWeight: 500,
                      color: "#0F0718",
                      height: "6vh",
                    }}
                  >
                    {product?.name}
                  </p>
                  <Row>
                    <Col
                      span={21}
                      style={{
                        fontSize: "1.25em",
                        fontWeight: "600",
                        color: "#0F0718",
                      }}
                    >
                      {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                      {product?.sunitprice}
                      {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                    </Col>
                    <Col
                      span={2}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "2px",
                      }}
                    >
                      <img src={removeBg} style={{ height: "1.8vh" }} />
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </InfiniteScroll>
  </Scrollbars>
</div> */}
          </div>

          {cart.items.length > 0 || localCart?.items?.length > 0 ? (
            <div style={{ background: "#fff", height: "100vh", width: "31%", position: "relative", fontSize: "1vw" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "2vh 1vw 0 1vw" }}>
                <span style={{ fontWeight: 600, fontSize: "1.5em", color: "#0F0718" }}>{getMultilingualText("Order Details")}</span>
                <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>{moment(cart.orderTime).format(userPreferences.dateFormat)}</span>
              </div>
              {localStorage.getItem("dineIn") === "Y" && cart.tableNo && (
                <p style={{ padding: "0 1vw", fontSize: "1.25em", color: "#0F0718", marginBottom: 0 }}>{/* {cart.tableNo} */}</p>
              )}

              {cart?.tableNo && localStorage.getItem("dineIn") === "Y" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 1vw",
                    marginBottom: "1vh",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      background: "#2F3850",
                      color: "#fff",
                      padding: "4px 26px 4px 10px",
                      borderRadius: "6px",
                      fontSize: "0.8rem",
                      width: "90px",
                      cursor: "pointer",
                      textAlign: "center",
                      userSelect: "none",
                    }}
                    onClick={() => {
                      if (selectedTable?.isSplitParent === "Y" || selectedTable?.isSplitRow || selectedTable?.splitTables?.length > 0) {
                        message.error("Cannot transfer bill for a split table.");
                        return;
                      }
                      setSeatGuestDrawerOpen(true);
                      setTransferBill(true);
                    }}
                  >
                    {cart.tableNo}
                    <span
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        width: "6px",
                        height: "6px",
                        borderLeft: "2px solid white",
                        borderBottom: "2px solid white",
                        transform: "translateY(-50%) rotate(-45deg)",
                        pointerEvents: "none",
                      }}
                    />
                  </div>

                  {/* {cart?.statusType === "OCU" && <span style={{ fontSize: "0.90rem" }}>{guestName}</span>} */}
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 1.2vw",
                  gap: "8px",
                }}
              >
                {/* LEFT SIDE */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  {tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === cart?.customer?.cwrCustomerId ? (
                    <button
                      style={{
                        color: "#0F0718",
                        backgroundColor: "#fff",
                        border: "1px solid #92909880",
                        fontSize: "0.85em",
                        borderRadius: "4px",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                        padding: "0.2vh 0.5vw",
                        cursor: "pointer",
                      }}
                      onClick={() => setDisplayCustomerSearch(true)}
                    >
                      <img src={userIcon} style={{ height: 15, width: "1.5vw", marginRight: "0.2vw" }} />
                      Add Customer
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#0F0718",
                        backgroundColor: "#fff",
                        border: "1px solid #92909880",
                        fontSize: "0.85em",
                        borderRadius: "4px",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                        padding: "0.2vh 0.5vw",
                        cursor: "pointer",
                      }}
                      onClick={() => setDisplayCustomerSearch(true)}
                    >
                      <img src={userIcon} style={{ height: 15, width: "1.5vw", marginRight: "0.2vw" }} />
                      {cart?.customer?.name}
                    </button>
                  )}
                </div>

                {/* RIGHT SIDE */}
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  {posConfig?.advanceLayaway === "Y" && localStorage.getItem("dineIn") !== "Y" && !isReturnOrder && (
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span style={{ fontSize: "0.75rem", fontWeight: 500 }}>Advance</span>

                      <Switch size="small" checked={cart?.wasLayaway ? !cart.finishLayaway : cart.layAway === "Y"} onChange={(checked) => handleAdvanceToggle(checked)} />
                    </div>
                  )}

                  {/* WAITER */}
                  {renderWaiterName()}
                </div>
              </div>
              <hr style={{ color: "#92909880", width: "93%" }} />
              {/* ---- TOP ACTION BUTTONS ---- */}
              {localStorage.getItem("dineIn") === "Y" && (
                <>
                  <div style={{ padding: "0 1vw", marginTop: "1vh" }}>
                    {/* FIRE ALL TO KITCHEN */}
                    <Button
                      onClick={() => {
                        setFireMode("all");
                        //setFireItems([]);// Use the same logic used when sending order to kitchen
                        handleOrder();
                      }}
                      style={{
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        borderRadius: "8px",
                        height: "4.5vh",
                        fontSize: "0.9em",
                        fontWeight: 600,
                        width: "100%",
                        marginBottom: "1vh",
                      }}
                    >
                      🚀 Fire All to Kitchen
                    </Button>

                    {/* REPRINT KOT + COPY KOT */}
                    <div style={{ display: "flex", gap: "1vw", marginBottom: "1.2vh" }}>
                      <Button
                        onClick={() => {
                          setShowReprintKotDialog(true);
                          //if (handleReprintKot) handleReprintKot();
                        }}
                        style={{
                          flex: 1,
                          height: "4.5vh",
                          borderRadius: "8px",
                          background: "#fff",
                          border: "1px solid #ccc",
                          fontSize: "0.85em",
                          fontWeight: 500,
                        }}
                      >
                        🧾 Reprint KOT
                      </Button>

                      <Button
                        onClick={openCopyKOTModal}
                        style={{
                          flex: 1,
                          height: "4.5vh",
                          borderRadius: "8px",
                          background: "#fff",
                          border: "1px solid #ccc",
                          fontSize: "0.85em",
                          fontWeight: 500,
                        }}
                      >
                        📋 Copy KOT
                      </Button>
                    </div>
                  </div>
                  <hr style={{ color: "#92909880", width: "93%" }} />
                </>
              )}
              <Scrollbars
                autoHide={false}
                style={{
                  // height: localStorage.getItem("dineIn") === "N" ? "40vh" : "57vh",
                  //height: isAllParkedState || localStorage.getItem("dineIn") === "Y" ? "33vh" : "52vh",
                  height: isAllParkedState ? "35vh" : "50vh",
                  width: "100%",
                }}
              >
                <InfiniteScroll
                  dataLength={cart.items.length}
                  hasMore={true}
                  style={{
                    height: "100%", // important
                  }}
                  endMessage={
                    <p className="center">
                      <b>Yay! you have seen it all</b>
                    </p>
                  }
                >
                  <div>
                    {Object.keys(groupedProducts).map(
                      (category, index) =>
                        groupedProducts[category].some((item) => item.order !== "Y") && (
                          <div key={index}>
                            <Text style={{ fontSize: "1em", fontWeight: "500", paddingLeft: "1rem", color: "#0F0718" }}>
                              {category} ({groupedProducts[category].filter((item) => item.order !== "Y").length})
                            </Text>
                            {groupedProducts[category]
                              .filter((item) => item.order !== "Y")
                              .map((item) => (
                                <div style={{ padding: "1px 10px" }}>
                                  <div
                                    key={item.id}
                                    style={{
                                      background: "#fff",
                                      borderRadius: "12px",
                                      border: selectedProductId === item.lineId ? "1px solid #b8c2cc" : "1px solid #E5E7EB",
                                      padding: "12px 14px",
                                      marginBottom: "10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (item.parkedItem) return;
                                      setSelectedProductId(item.lineId);
                                      setSelectedProductInCart(item);
                                    }}
                                  >
                                    {/* TOP ROW — NAME + BADGE + PRICE */}
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <span
                                          style={{
                                            fontWeight: 600,
                                            fontSize: "0.8rem",
                                            maxWidth: "160px", // adjust width
                                            display: "inline-block",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            verticalAlign: "bottom",
                                          }}
                                          title={item?.productAliasName ? item?.productAliasName : item.name} // show full name on hover
                                        >
                                          {item?.productAliasName ? item?.productAliasName : item.name}
                                        </span>

                                        <div
                                          style={{
                                            background: item.isHold ? "#FDE68A" : "#F3F4F6",
                                            padding: "1px 6px",
                                            fontSize: "0.6rem",
                                            borderRadius: 4,
                                          }}
                                        >
                                          {item.isHold ? "Hold" : "Editing"}
                                        </div>
                                      </div>

                                      <span style={{ fontWeight: 700, fontSize: "0.9rem" }}>
                                        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                        {toFixedTruncate(item.nettotal, item?.isQtyDesimal)}
                                        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                      </span>
                                    </div>

                                    {/* SUB PRICE + NOTES */}
                                    {/* SUB PRICE + NOTES (INLINE) */}
                                    <div
                                      style={{
                                        marginTop: 4,
                                        fontSize: "0.75rem",
                                        color: "#555",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      {/* small price */}
                                      {item?.selectedAddons?.length > 0 && (
                                        <span
                                          style={{
                                            fontSize: "0.65rem",
                                            color: "#6B7280",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "180px",
                                          }}
                                          title={item.selectedAddons.map((a) => a.name).join(", ")}
                                        >
                                          {item.selectedAddons.map((a) => a.name).join(", ")}
                                        </span>
                                      )}

                                      {/* notes preview inline */}
                                      {item.notes && (
                                        <span
                                          style={{
                                            fontSize: "0.65rem",
                                            color: "#6B7280",
                                            maxWidth: "200px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                          title={item.notes}
                                        >
                                          📝 {item.notes}
                                        </span>
                                      )}
                                    </div>

                                    {/* QTY + ACTION ICONS */}
                                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                                      {/* QTY */}
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          background: "#F3F4F6",
                                          padding: "6px 10px",
                                          borderRadius: "8px",
                                          fontSize: "0.8rem",
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <button style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: "1rem" }} onClick={() => decreaseProductQty(item)}>
                                          –
                                        </button>

                                        <span>{item.weight || item.qty}</span>

                                        <button style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: "1rem" }} onClick={() => increaseProductQty(item)}>
                                          +
                                        </button>
                                      </div>

                                      {/* ICONS */}
                                      <div style={{ display: "flex", alignItems: "center", gap: "14px", fontSize: 18 }}>
                                        {/* FIRE */}
                                        {localStorage.getItem("dineIn") === "Y" && (
                                          <FireOutlined
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setFireMode("single");
                                              setFireItems([item]);
                                              handleOrder([item]);
                                            }}
                                          />
                                        )}

                                        {/* HOLD */}
                                        {localStorage.getItem("dineIn") === "Y" && (
                                          <PauseOutlined
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                              e.stopPropagation();

                                              const updatedItems = cart.items.map((i) => {
                                                if (i.lineId === item.lineId) {
                                                  if (i.isHold) {
                                                    // UNHOLD FLOW
                                                    return {
                                                      ...i,
                                                      isHold: false,
                                                      order: "N",
                                                      firedQty: 0,
                                                    };
                                                  } else {
                                                    // HOLD FLOW
                                                    return {
                                                      ...i,
                                                      isHold: true,
                                                    };
                                                  }
                                                }
                                                return i;
                                              });

                                              const updatedCart = { ...cart, items: updatedItems };
                                              setCart(updatedCart);
                                              localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                                            }}
                                          />
                                        )}

                                        {/* PRODUCTION CENTER */}
                                        {localStorage.getItem("dineIn") === "Y" && (
                                          <RadarChartOutlined
                                            style={{ cursor: "pointer", color: item.productionCenterId ? "#715C63" : "#2F3856" }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setProdItem(item);
                                              setShowProdCenterModal(true);
                                            }}
                                          />
                                        )}

                                        {/* SALE TYPE */}
                                        {localStorage.getItem("dineIn") === "Y" && (
                                          <ShopOutlined
                                            style={{
                                              cursor: "pointer",
                                              color: item.saleType
                                                ? item.saleType === "DI"
                                                  ? "#715C63" // Dine In
                                                  : "#00B894" // Take Away
                                                : "#2F3856", // not selected
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setSaleTypeModalItem(item);
                                              setSaleTypeModalOpen(true);
                                            }}
                                          />
                                        )}

                                        {/* NOTES */}
                                        <MessageOutlined
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedItem(item);
                                            setSelectedItemNotes(item);
                                            setNotesValue(item.notes || "");
                                            setNotesPopup(true);
                                          }}
                                        />
                                      </div>
                                    </div>

                                    {/* DISCOUNT BADGE */}
                                    {Math.abs(item.discount) > 0 && (
                                      <span
                                        style={{
                                          background: "#F8C519",
                                          borderRadius: 3,
                                          padding: "2px 5px",
                                          fontSize: "0.65rem",
                                          marginTop: 6,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 4,
                                        }}
                                      >
                                        <img src={Offers} alt="" width={12} height={12} />
                                        {item.discountName}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              ))}
                            <hr style={{ color: "#92909880", width: "92.5%" }} />
                          </div>
                        )
                    )}
                    {hasFiredItems && (
                      <>
                        <div
                          style={{
                            margin: "0px 0 0px 10px",
                            fontWeight: 500,
                            fontSize: "0.7rem",
                            color: "#6B7280",
                          }}
                        >
                          Fired Items
                        </div>

                        {Object.keys(groupedProducts).map(
                          (category, index) =>
                            groupedProducts[category].some((item) => item.order === "Y") && (
                              <div key={`fired-${index}`}>
                                <Text
                                  style={{
                                    fontSize: "0.8em",
                                    fontWeight: 500,
                                    paddingLeft: "0.6rem",
                                    color: "#9CA3AF",
                                  }}
                                >
                                  {category} ({groupedProducts[category].filter((item) => item.order === "Y").length})
                                </Text>

                                {groupedProducts[category]
                                  .filter((item) => item.order === "Y")
                                  .map((item) => (
                                    <div
                                      key={item.id}
                                      // style={{ fontSize: "0.9vw", backgroundColor: selectedProductId === item.lineId ? "#f0f0f0" : "transparent" }}
                                      onClick={() => {
                                        if (item.parkedItem) return;
                                        if (localStorage.getItem("dineIn") === "N") {
                                          setSelectedProductId(item.lineId);
                                          setSelectedProductInCart(item);
                                        }
                                      }}
                                    >
                                      <Row>
                                        {/* ---------- NEW PRODUCT CARD UI (COMPACT + RESPONSIVE) ---------- */}
                                        <div
                                          style={{
                                            width: "100%",
                                            padding: "2px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            fontSize: "0.9rem",
                                          }}
                                        >
                                          {/* <div
                                            style={{
                                              fontWeight: 400,
                                              fontSize: "0.7rem",
                                              color: selectedProductId === item.lineId ? "#0F0718" : "#afb7c3",
                                              marginLeft: 7,
                                              cursor: "pointer",
                                              backgroundColor: "transparent",
                                            }}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => {
                                              setSelectedProductId(item.lineId), setSelectedProductInCart(item);
                                            }}
                                          >
                                            {item.name} <span style={{ color: "#afb7c3" }}> × {item.weight}</span>
                                          </div> */}
                                          <div
                                            title={item.selectedAddons?.length > 2 ? item.selectedAddons.map((a) => a.name).join(", ") : ""}
                                            style={{
                                              fontWeight: 400,
                                              fontSize: "0.7rem",
                                              color: item.isCanceled === "Y" ? "#9CA3AF" : selectedProductId === item.lineId ? "#0F0718" : "#afb7c3",
                                              marginLeft: 7,
                                              cursor: item.isCanceled === "Y" ? "not-allowed" : "pointer",
                                              backgroundColor: "transparent",
                                              textDecoration: item.isCanceled === "Y" ? "line-through" : "none",
                                            }}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => {
                                              if (item.isCanceled === "Y") return; // 🚫 prevent click
                                              setSelectedProductId(item.lineId);
                                              setSelectedProductInCart(item);
                                            }}
                                          >
                                            {item?.productAliasName ? item?.productAliasName : item.name}

                                            {item.selectedAddons?.length > 0 && (
                                              <span style={{ color: "#afb7c3" }}>
                                                {" ("}
                                                {getAddonPreview(item.selectedAddons)}
                                                {")"}
                                              </span>
                                            )}

                                            <span style={{ color: "#afb7c3" }}>
                                              {" × "}
                                              {item.weight}
                                            </span>
                                          </div>

                                          <div style={{ display: "flex", alignItems: "center", gap: 6, marginRight: 5 }}>
                                            {/* <div style={{ fontSize: "0.7rem", fontWeight: 400, color: "#afb7c3" }}>
                                              {currenciesList[0].symbolRightSide === "Y" && <span>{currenciesList[0].currSymbol}&nbsp;</span>}

                                              {toFixedTruncate(item.nettotal, item?.isQtyDesimal)}

                                              {currenciesList[0].symbolRightSide === "N" && <span>&nbsp;{currenciesList[0].currSymbol}</span>}
                                            </div> */}

                                            <div
                                              style={{
                                                fontSize: "0.7rem",
                                                fontWeight: 400,
                                                color: item.isCanceled === "Y" ? "#9CA3AF" : "#afb7c3",
                                                textDecoration: item.isCanceled === "Y" ? "line-through" : "none",
                                              }}
                                            >
                                              {currenciesList[0].symbolRightSide === "Y" && <span>{currenciesList[0].currSymbol}&nbsp;</span>}

                                              {toFixedTruncate(item.nettotal, item?.isQtyDesimal)}

                                              {currenciesList[0].symbolRightSide === "N" && <span>&nbsp;{currenciesList[0].currSymbol}</span>}
                                            </div>

                                            <div
                                              style={{
                                                background: item.isCanceled === "Y" ? "#db4444ff" : "#9fa4ae",
                                                color: "#fff",
                                                padding: "0px 7px",
                                                borderRadius: 4,
                                                fontSize: "0.6rem",
                                                fontWeight: 400,
                                                marginRight: 5,
                                              }}
                                            >
                                              {item.isCanceled === "Y" ? "Cancelled" : "Fired"}
                                            </div>
                                          </div>
                                        </div>
                                      </Row>
                                      <span
                                        style={{
                                          background: Math.abs(item.discount) > 0 ? "#F8C519" : "",
                                          borderRadius: "3px",
                                          padding: "0.1vw",
                                          display: item.discountName ? "" : "none",
                                          fontSize: "0.65em",
                                          marginLeft: "0.6vw",
                                        }}
                                      >
                                        {Math.abs(item.discount) > 0 ? item.discountName ? <img src={Offers} alt="" width={12} height={12} /> : "" : ""}{" "}
                                        {Math.abs(item.discount) > 0 ? item.discountName || "" : ""}{" "}
                                      </span>
                                    </div>
                                  ))}

                                <hr style={{ color: "#92909880", width: "92.5%" }} />
                              </div>
                            )
                        )}
                      </>
                    )}
                  </div>
                </InfiniteScroll>
              </Scrollbars>
              <div style={{ padding: "1vh 0.6vw", position: "absolute", bottom: "1vh", fontSize: "1vw", width: "100%" }}>
                <div
                  onClick={() => setShowDetails(!showDetails)}
                  style={{
                    cursor: "pointer",
                    fontWeight: 500,
                    fontSize: "1em",
                    background: "#F3F4F9",
                    padding: "0.5vh 0.5vw",
                    borderRadius: "5px",
                    marginBottom: "1vh",
                  }}
                >
                  View Details <span style={{ color: "#6B7280" }}>{showDetails ? "▲" : "▼"}</span>
                </div>
                {showDetails && (
                  <Scrollbars style={{ height: "18vh" }}>
                    <Space
                      direction="vertical"
                      style={{
                        width: "100%",
                        background: "#F3F4F9",
                        padding: "1vh 0.5vw",
                        borderRadius: "10px",
                        rowGap: "4px",
                      }}
                    >
                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Subtotal")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {/* {(cart?.total - cart?.tax).toFixed(2)} */}
                          {toFixedTruncate(cart?.total - cart?.tax, pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Text>
                      </Space>

                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Discount Sales")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {/* {parseFloat(cart.discount).toFixed(2)} */}
                          {toFixedTruncate(cart.discount, pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Text>
                      </Space>

                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Total Sales Tax")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {/* {parseFloat(cart.tax).toFixed(2)} */}
                          {toFixedTruncate(cart.tax, pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Text>
                      </Space>

                      {serviceChargeAmount > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Service Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {/* {parseFloat(serviceChargeAmount).toFixed(2)} */}
                            {toFixedTruncate(serviceChargeAmount, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                          </Text>
                        </Space>
                      )}

                      {tipTotal > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Tip")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {/* {parseFloat(tipTotal).toFixed(2)} */}
                            {toFixedTruncate(tipTotal, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                          </Text>
                        </Space>
                      )}

                      {deliveryChargeAmount > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Delivery Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {/* {parseFloat(deliveryCharge).toFixed(2)} */}
                            {toFixedTruncate(deliveryChargeAmount, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                          </Text>
                        </Space>
                      )}

                      {packingChargeAmount > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Packing Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {/* {parseFloat(packingCharge).toFixed(2)} */}
                            {toFixedTruncate(packingChargeAmount, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                          </Text>
                        </Space>
                      )}
                    </Space>
                  </Scrollbars>
                )}
                <Space style={{ width: "100%", justifyContent: "space-between", marginTop: "2px" }}>
                  <Text style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 600 }}>{getMultilingualText("Total Amount")}</Text>
                  <Text style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 600 }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {/* {(Math.floor(parseFloat(cart.total) * 100) / 100 + AdditionalChargesTotal).toFixed(2)} */}
                    {toFixedTruncate(Math.floor(parseFloat(cart.total) * 100) / 100 + AdditionalChargesTotal, pricePrecision)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                  </Text>
                </Space>
                {renderAddtionalChargesPrepareSplitBillButtons()}
                {renderHoldOrderDiscountButtons()}
                {renderCancelPayBillButtons()}
              </div>
            </div>
          ) : null}

          {/* Modal for product details */}

          {/* modal for add on's starts */}

          <Modal
            closable={false}
            footer={null}
            bodyStyle={{
              padding: 16,
              background: "#fff",
              height: "60vh",
              display: "flex",
              flexDirection: "column",
            }}
            visible={layout === "2" && displayAddOnSelection}
            onCancel={handleAddOnModalClose}
            centered
            // width={
            //   (addOnsList?.requiredList?.length > 0 && Object.entries(_.groupBy(addOnsList?.optionsList, "mAddonGroup.name"))?.length === 0) ||
            //   (addOnsList?.requiredList?.length === 0 && Object.entries(_.groupBy(addOnsList?.optionsList, "mAddonGroup.name"))?.length === 1)
            //     ? "35%"
            //     : addOnsList?.requiredList?.length > 0 && Object.entries(_.groupBy(addOnsList?.optionsList, "mAddonGroup.name"))?.length === 1
            //     ? "48%"
            //     : "60%"
            // }
            width={"32%"}
          >
            <Row
              style={{
                padding: "6px 8px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Col>
                <img src={removeBg} style={{ height: "2vh", marginRight: 6 }} />
                <span style={{ fontSize: "1.2em", fontWeight: 600 }}>{selectedProduct?.name}</span>
              </Col>

              <Col>
                <span style={{ fontSize: "1.2em", fontWeight: 600 }}>
                  {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                  {selectedProduct?.sunitprice}
                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                </span>
              </Col>
            </Row>
            <Row
              style={{
                alignItems: "center",
                justifyContent: "space-between",
                margin: "8px 5px",
              }}
            >
              <Col>
                <p style={{ fontSize: "1.2em", fontWeight: 600, margin: 0 }}>{getMultilingualText("Add On's")}</p>
              </Col>

              <Col style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Button icon={<MinusOutlined />} style={{ width: 25, height: 25 }} onClick={() => handleQty("minus")} />

                <span style={{ fontSize: "1.2em", fontWeight: 600 }}>{selectedProduct?.weight || 1}</span>

                <Button icon={<PlusOutlined style={{ color: "#fff" }} />} style={{ width: 25, height: 25, background: "#2F3856" }} onClick={() => handleQty("plus")} />
              </Col>
            </Row>
            <div style={{ flex: 1, overflow: "hidden" }}>
              <Scrollbars autoHide style={{ height: "100%" }}>
                <Row>
                  <Col span={24} style={{ paddingRight: 3, paddingBottom: 10 }}>
                    <Card bodyStyle={{ padding: 5 }} style={data.restaurantPos.content.addOnSelectionModal.mainCard}>
                      {/* Required Add-Ons */}
                      {addOnsList?.requiredList?.length > 0 &&
                        Object.entries(_.groupBy(addOnsList.requiredList, (a) => a.mAddonGroup.mAddonGroupId)).map(([groupId, items]) => {
                          const groupInfo = items[0].mAddonGroup;
                          const max = groupInfo.maxqty;
                          if (max === 0) return null;
                          const selectedGroupItems = selectedAddons.filter((a) => a.mAddonGroup.mAddonGroupId === groupId);

                          return (
                            <div key={groupId}>
                              <p style={{ fontWeight: 600, margin: "6px 0" }}>{groupInfo.name}</p>

                              {/* 👉 if max = 1 use radio */}
                              {max === 1 ? (
                                <Radio.Group value={selectedGroupItems[0]} onChange={(e) => handleAddOnValue(e, "addOnRadio")} style={{ width: "100%" }}>
                                  {items.map((item) => (
                                    <Card key={item.mProductAddOnId} bodyStyle={{ padding: 10 }}>
                                      <Radio value={item}>{item?.productAliasName ? item?.productAliasName : item.name}</Radio>
                                    </Card>
                                  ))}
                                </Radio.Group>
                              ) : (
                                /* 👉 if max > 1 use checkbox */
                                items.map((item) => {
                                  const existing = selectedAddons.find((a) => a.mProductAddOnId === item.mProductAddOnId);

                                  const checked = !!existing;
                                  const qty = existing?.qty || 0;

                                  return (
                                    <Card key={item.mProductAddOnId} bodyStyle={{ padding: 10 }}>
                                      <Row justify="space-between" align="middle">
                                        <Col>
                                          <Checkbox
                                            checked={checked}
                                            onChange={(e) => {
                                              const allowQty = item.mAddonGroup.allowQtySelection === "Y";

                                              if (e.target.checked) {
                                                updateAddonQty(item, 1);
                                              } else {
                                                updateAddonQty(item, -999);
                                              }
                                            }}
                                          >
                                            {item?.productAliasName ? item?.productAliasName : item.name}
                                          </Checkbox>
                                        </Col>

                                        {/* show qty only if selected */}
                                        {checked && item.mAddonGroup.allowQtySelection === "Y" && (
                                          <Col>
                                            <Button size="small" onClick={() => updateAddonQty(item, -1)} disabled={qty <= 1}>
                                              -
                                            </Button>

                                            <span style={{ margin: "0 10px" }}>{qty}</span>

                                            <Button size="small" onClick={() => updateAddonQty(item, +1)}>
                                              +
                                            </Button>
                                          </Col>
                                        )}
                                      </Row>
                                    </Card>
                                  );
                                })
                              )}
                            </div>
                          );
                        })}
                      {addOnsList?.optionsList?.length > 0 &&
                        Object.entries(_.groupBy(addOnsList.optionsList, (a) => a.mAddonGroup.mAddonGroupId)).map(([groupId, items]) => {
                          const groupInfo = items[0].mAddonGroup;
                          const max = groupInfo.maxqty;

                          // 🔴 HIDE GROUP IF MAX = 0
                          if (max === 0) return null;

                          return (
                            <div key={groupId}>
                              <p style={{ fontWeight: 600, margin: "6px 0" }}>{groupInfo.name}</p>

                              {items.map((item) => {
                                const existing = selectedAddons.find((a) => a.mProductAddOnId === item.mProductAddOnId);

                                const checked = !!existing;
                                const qty = existing?.qty || 0;

                                return (
                                  <Card key={item.mProductAddOnId} bodyStyle={{ padding: 10 }}>
                                    <Row justify="space-between" align="middle">
                                      <Col>
                                        <Checkbox
                                          checked={checked}
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              updateAddonQty(item, +1);
                                            } else {
                                              updateAddonQty(item, -999);
                                            }
                                          }}
                                        >
                                          {item?.productAliasName ? item?.productAliasName : item.name}
                                        </Checkbox>
                                      </Col>

                                      {/* show qty only if selected */}
                                      {checked && item.mAddonGroup.allowQtySelection === "Y" && (
                                        <Col>
                                          <Button size="small" onClick={() => updateAddonQty(item, -1)} disabled={qty <= 1}>
                                            -
                                          </Button>

                                          <span style={{ margin: "0 10px" }}>{qty}</span>

                                          <Button size="small" onClick={() => updateAddonQty(item, +1)}>
                                            +
                                          </Button>
                                        </Col>
                                      )}
                                    </Row>
                                  </Card>
                                );
                              })}
                            </div>
                          );
                        })}
                    </Card>
                  </Col>
                </Row>
              </Scrollbars>
            </div>

            <Row style={{ marginTop: 10 }}>
              <Col span={24} style={{ fontSize: "1vw" }}>
                <Button style={data.restaurantPos.content.orderCart.checkoutBtn} className="addButton" onClick={handleAdd}>
                  <span style={data.restaurantPos.content.orderCart.checkoutBtn.label}>{getMultilingualText("Add to Cart")}</span>
                </Button>
              </Col>
            </Row>
          </Modal>

          <Drawer
            placement="bottom"
            height="53vh"
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "2vh",
                  fontSize: "1vw",
                }}
              >
                <p
                  style={{
                    fontSize: "1.5em",
                    marginTop: "3vh",
                    fontWeight: "500",
                    color: "#0F0718",
                    flex: 1,
                    textAlign: "center",
                  }}
                >
                  Add Notes for Item
                </p>
                <img
                  src={Close}
                  onClick={() => {
                    setNotesPopup(false);
                    setNotesValue("");
                  }}
                  style={{
                    marginLeft: "auto",
                    paddingBottom: "4vh",
                    paddingTop: "2vh",
                    cursor: "pointer",
                    width: "1.5vw",
                  }}
                />
              </div>
            }
            closeIcon={null}
            className="filter"
            bodyStyle={{ paddingTop: 0 }}
            visible={notesPopup}
            closable={true}
            onClose={() => {
              setNotesPopup(false);
            }}
            footer={null}
          >
            <Row style={{ padding: "0 5vw", fontSize: "1vw" }}>
              <Col
                span={11}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                }}
              >
                <TextArea id="notes-input" style={{ resize: "none" }} maxLength={200} onChange={(e) => setNotesValue(e.target.value)} value={notesValue} rows={9} />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "8px",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontSize: "0.8em",
                      color: "#929098",
                      fontWeight: 500,
                    }}
                  >
                    Max Characters : 200
                  </span>
                  <span
                    style={{
                      color: "#929098",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontFamily: "Inter",
                      fontSize: "0.8em",
                      fontWeight: 500,
                    }}
                    onClick={() => {
                      setNotesValue("");
                      const updatedCartItems = cart.items.map((cartItem) => (cartItem.id === selectedItem.id ? { ...cartItem, notes: "" } : cartItem));
                      setCart({ ...cart, items: updatedCartItems });

                      if (selectedItem) {
                        setSelectedItem({ ...selectedItem, notes: "" });
                      }
                      setNotesPopup(false);
                    }}
                  >
                    Clear Notes
                  </span>
                </div>
              </Col>

              <Col span={12} offset={1}>
                <Keyboard
                  theme={"hg-theme-default aprvl"}
                  onKeyPress={(button) => {
                    if (button === "{backspace}") {
                      setNotesValue((prev) => prev.slice(0, -1));
                    } else if (button === "{space}") {
                      setNotesValue((prev) => prev + " ");
                    } else if (button === "{shift}" || button === "{lock}") {
                      handleShift();
                    } else if (button === "{number}") {
                      setLayoutName("number");
                    } else if (button === "{numbers}") {
                      setLayoutName("numbers");
                    } else if (button === "{small}") {
                      setLayoutName("shift");
                    } else if (button === "{caps}") {
                      setLayoutName("default");
                    } else if (button === "{enter}") {
                      if (selectedItem) {
                        const updatedCartItems = cart.items.map((cartItem) => (cartItem.lineId === selectedItem.lineId ? { ...cartItem, notes: notesValue } : cartItem));
                        setCart({ ...cart, items: updatedCartItems });
                        selectedItem.notes = notesValue;
                        setInstructions(notesValue);
                        setNotesPopup(false);
                      }
                    } else {
                      setNotesValue((prev) => prev + button);
                    }
                  }}
                  layoutName={layoutName}
                  display={{
                    "{abc}": "ABC",
                    "{smileys}": "\uD83D\uDE03",
                    "{back}": "Enter",
                    "{numbers}": "123",
                    "{number}": "123",
                    "{bksp}": "backspace",
                    "{backspace}": "⌫",
                    "{shift}": "⇧",
                    "{tab}": "tab",
                    "{lock}": "lock",
                    "{enter}": "Enter",
                    "{space}": "Space",
                    "{caps}": "ABC",
                    "{small}": "abc",
                  }}
                  layout={
                    posConfig?.keyboardLanguage === "Y" && posConfig?.selectedKeyboardLanguage === "ar"
                      ? {
                          shift: ["ض ص ث ق ف غ ع ه خ ح ج د", "ش س ي ب ل ا ت ن م ك ط", "{shift} ئ ء ؤ ر ى ة و ز ظ أ إ آ ـ {backspace}", "{number} {space} {enter}"],
                          numbers: ["١ ٢ ٣ ٤ ٥ ٦ ٧ ٨ ٩ ٠", "! @ # $ % ^ & * ( )", "- . ، _ / ؛ ؟ {backspace}", "{caps} {space} {enter}"],
                          number: ["١ ٢ ٣ ٤ ٥ ٦ ٧ ٨ ٩ ٠", "! @ # $ % ^ & * ( )", "- . ، _ / ؛ ؟ {backspace}", "{small} {space} {enter}"],
                          default: ["ض ص ث ق ف غ ع ه خ ح ج د", "ش س ي ب ل ا ت ن م ك ط", "{shift} ئ ء ؤ ر ى ة و ز ظ أ إ آ ـ {backspace}", "{numbers} {space} {enter}"],
                        }
                      : {
                          shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                          numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                          number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                          default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
                        }
                  }
                />
              </Col>
            </Row>
          </Drawer>
          {/* {paymentVisible && <OrderListComponent {...props} />} */}
        </div>
      )}
      <Drawer
        placement="bottom"
        closable={false}
        maskClosable={false}
        className="filter"
        bodyStyle={{ paddingBottom: 0 }}
        onClose={() => {
          setFilterDrawer(false);
          setProductSearchInput("");
          setSelectCategotyList([]);
          setProductsData(saleTypeProducts);
        }}
        id="sm-drawer-close"
        height="89vh"
        visible={filterDrawer}
      >
        <Col span={24} style={{ fontSize: "1vw", padding: "0 2vw", height: "83vh" }}>
          {loading ? (
            <>
              {[...Array(12)].map((_, index) => (
                <Card key={index} style={{ marginBottom: "1vh", padding: "12px", borderRadius: "8px" }}>
                  <Skeleton active paragraph={{ rows: 2 }} />
                </Card>
              ))}
            </>
          ) : (
            <>
              {/* Close button */}
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
                <CloseOutlined
                  onClick={() => {
                    setFilterDrawer(false);
                    setProductSearchInput("");
                    setSelectCategotyList([]);
                    setProductsData(saleTypeProducts);
                  }}
                  style={{ fontSize: "1.2vw", cursor: "pointer" }}
                />
              </div>

              {/* Search + Sort */}
              <Row style={{ marginBottom: "1vh", width: "100%", display: "flex", alignItems: "center" }}>
                <Col span={24}>
                  <Input
                    ref={productPanelSearchRef}
                    placeholder="Search for products by code/name"
                    id="sm-product-search"
                    value={productSearchInput}
                    onChange={(e) => {
                      setProductSearchInput(e.target.value.toLowerCase());
                    }}
                    style={{
                      width: "100%",
                      borderRadius: "7px",
                      padding: "0.8vh 0.8vw",
                      borderColor: "#fff",
                      backgroundColor: "#fff",
                      height: "5vh",
                      fontSize: "1em",
                    }}
                    onFocus={() => {
                      setOpen(true);
                      setTimeout(() => {
                        setInputName("productSearch1");
                        keyboard?.current?.setInput(productSearchInput);
                      }, 150);
                    }}
                    onPressEnter={() => {
                      const filtered = applySearchFilter(productSearchInput, selectCategotyList);
                      setProductsData(filtered);
                      keyboard?.current?.setInput(productSearchInput);
                    }}
                    prefix={
                      <img
                        src={SearchIcon}
                        alt=""
                        onClick={() => {
                          const value = productSearchInput.toLowerCase().trim();
                          const filtered = saleTypeProducts.filter((product) => {
                            const matchesText =
                              product.name.toLowerCase().includes(value) ||
                              product.value?.toLowerCase().includes(value) ||
                              product.code?.toLowerCase().includes(value) ||
                              product?.productAliasName?.toLowerCase().includes(value);
                            const matchesCategory = selectCategotyList.length === 0 || selectCategotyList.includes(product.mProductCategoryId);
                            return matchesText && matchesCategory;
                          });
                          setProductsData(filtered);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    }
                    suffix={
                      productSearchInput?.length > 0 ? (
                        <CloseSquareFilled
                          style={{ fontSize: "20px", color: "#2F3856" }}
                          onClick={async () => {
                            setProductSearchInput("");
                            if (selectCategotyList.length === 0) {
                              setProductsData(saleTypeProducts);
                            } else {
                              setProductsData(saleTypeProducts.filter((product) => selectCategotyList.includes(product.mProductCategoryId)));
                            }
                            setTimeout(() => {
                              setOpen(false);
                              const productSearchInput = document.getElementById("sm-product-search");
                              if (productSearchInput) {
                                productSearchInput.blur();
                              }
                              keyboard?.current?.setInput("");
                            }, 200);
                          }}
                        />
                      ) : null
                    }
                  />
                </Col>
              </Row>

              {/* Categories */}
              <div style={{ display: "flex", overflowX: "auto", paddingBottom: "1%", paddingLeft: "0.1rem" }}>
                {productCategoriesList
                  .slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((category) => (
                    <button
                      key={category.mProductCategoryId}
                      onClick={() => {
                        const newCategory = [category.mProductCategoryId];
                        setSelectCategotyList(newCategory);
                        setCategorieName(category.name);
                        restaurantProductCategory(category.mProductCategoryId);
                        setCategorieFlag(true);
                        const filtered = applySearchFilter(productSearchInput, newCategory);
                        setProductsData(filtered);
                      }}
                      style={{
                        background: selectCategotyList.includes(category.mProductCategoryId) ? "#eff6ff" : "#fff",
                        color: selectCategotyList.includes(category.mProductCategoryId) ? "#2563eb" : "#0F0718",
                        fontWeight: 500,
                        border: "none",
                        padding: "0.5vh 0.5vw",
                        height: "6vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        whiteSpace: "nowrap",
                        fontSize: "1em",
                        fontFamily: "Inter",
                        cursor: "pointer",
                      }}
                    >
                      {category.name}
                      <Badge
                        count={saleTypeProducts.filter((product) => product.mProductCategoryId === category.mProductCategoryId).length}
                        style={{
                          backgroundColor: "#f5f5f5",
                          color: "#0F0718",
                          fontSize: "0.8em",
                          padding: "0px 8px",
                          borderRadius: "10px",
                          marginLeft: "0.5em",
                        }}
                      />
                    </button>
                  ))}
              </div>

              {/* Product Grid */}
              <Scrollbars style={{ height: "65vh" }}>
                {/* === Determine showImage flag once === */}
                {(() => {
                  // Helper: Minimal card when showImage is N
                  const MinimalCard = ({ product }) => (
                    <Card
                      key={product.mProductId}
                      style={{
                        borderRadius: "10px",
                        border: "1px solid #e8e8e8",
                        padding: "10px",
                        cursor: "pointer",
                        color: "#0F0718",
                        fontWeight: "500",
                        backgroundColor: getColorFromId(product.mProductId),
                        overflow: "hidden",
                        height: "90px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        position: "relative",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        product?.productAddons?.length > 0 && product?.showAddons === "Y" ? handleAddOnModal(product, e) : pickProduct(product);
                      }}
                    >
                      <p
                        title={product?.productAliasName ? product?.productAliasName : product.name}
                        style={{
                          fontWeight: 500,
                          fontSize: "13px",
                          margin: 0,
                          lineHeight: "1.4",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          padding: "0 4px",
                        }}
                      >
                        {product?.productAliasName ? product?.productAliasName : product.name}
                      </p>

                      <p
                        style={{
                          color: "green",
                          fontWeight: 500,
                          fontSize: "12px",
                          margin: 0,
                          position: "absolute",
                          bottom: "8px",
                          right: "10px",
                        }}
                      >
                        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                        {product.sunitprice.toFixed(2)}
                        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                      </p>
                    </Card>
                  );

                  // Helper: Rich card when showImage is Y
                  const RichCard = ({ product }) => (
                    <Card
                      key={product.mProductId}
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #e8e8e8",
                        cursor: "pointer",
                        position: "relative",
                        padding: "12px",
                        overflow: "visible",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        product?.productAddons?.length > 0 && product?.showAddons === "Y" ? handleAddOnModal(product, e) : pickProduct(product);
                      }}
                    >
                      <div
                        style={{
                          height: "60px",
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "8px",
                          overflow: "visible",
                          position: "relative",
                        }}
                      >
                        <img
                          src={product.imageurl || DefaultProductImage}
                          alt={product?.productAliasName ? product?.productAliasName : product.name}
                          style={{
                            width: product.imageurl ? "100%" : "40px",
                            height: product.imageurl ? "100%" : "40px",
                            objectFit: product.imageurl ? "cover" : "contain",
                            margin: product.imageurl ? "0" : "auto",
                          }}
                        />
                        {product.isBestSeller && (
                          <div
                            style={{
                              position: "absolute",
                              top: "4px",
                              right: "4px",
                              backgroundColor: "#eab308",
                              padding: "2px 6px",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "10px",
                              fontSize: "10px",
                              fontWeight: 500,
                              zIndex: 1,
                              pointerEvents: "none",
                            }}
                          >
                            <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
                            Best
                          </div>
                        )}
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        <h3
                          title={product?.name}
                          style={{
                            fontSize: "0.8em",
                            fontWeight: "600",
                            color: "#0F0718",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {product?.productAliasName ? product?.productAliasName : product.name}
                        </h3>
                        <div style={{ fontSize: "0.8rem", color: "#4b5563", marginBottom: "0.25rem" }}>
                          <span style={{ fontWeight: "500" }}>{product.value}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <span style={{ fontSize: "0.9em", fontWeight: "700", color: "#389e0d" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                            {product.sunitprice.toFixed(2)}
                            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}/{product.uomName}
                          </span>
                          <Col
                            span={2}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginLeft: "2px",
                            }}
                          >
                            {getFoodTypeIcon(product.foodType) && <img src={getFoodTypeIcon(product.foodType)} style={{ height: "1.8vh" }} />}
                          </Col>
                        </div>
                      </div>
                    </Card>
                  );

                  // Render Best Sellers
                  const renderBestSellers = () => {
                    const filtered = frequentProducts.filter((p) => selectCategotyList.length === 0 || selectCategotyList.includes(p.mProductCategoryId));
                    if (filtered.length === 0) return null;

                    return (
                      <div style={{ marginBottom: "2vh" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "3px", marginBottom: "1vh" }}>
                          <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>Best Sellers</h2>
                          <Badge
                            count={filtered.length}
                            style={{
                              backgroundColor: "#f5f5f5",
                              color: "#0F0718",
                              fontSize: "0.8em",
                              padding: "0px 8px",
                              borderRadius: "10px",
                            }}
                          />
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "12px" }}>
                          {filtered.map((product) =>
                            showImage ? <RichCard key={product.mProductId} product={product} /> : <MinimalCard key={product.mProductId} product={product} />
                          )}
                        </div>
                      </div>
                    );
                  };

                  // Render All Products
                  const renderAllProducts = () => {
                    const filtered = nonfrequentProducts.filter((p) => selectCategotyList.length === 0 || selectCategotyList.includes(p.mProductCategoryId));
                    if (filtered.length === 0) return null;

                    return (
                      <div style={{ marginBottom: "2vh" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "3px", marginBottom: "1vh" }}>
                          <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>All Products</h2>
                          <Badge
                            count={filtered.length}
                            style={{
                              backgroundColor: "#f5f5f5",
                              color: "#0F0718",
                              fontSize: "0.8em",
                              padding: "0px 8px",
                              borderRadius: "10px",
                            }}
                          />
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "12px" }}>
                          {filtered.map((product) =>
                            showImage ? <RichCard key={product.mProductId} product={product} /> : <MinimalCard key={product.mProductId} product={product} />
                          )}
                        </div>
                      </div>
                    );
                  };

                  return (
                    <>
                      {renderBestSellers()}
                      {renderAllProducts()}
                    </>
                  );
                })()}
              </Scrollbars>
            </>
          )}
        </Col>
      </Drawer>
      <Drawer
        title={
          <div style={{ display: "flex", fontSize: "1vw", alignItems: "center" }}>
            <p style={{ fontSize: "1.5em", fontWeight: 600, color: "#0F0718", flex: 1 }}>Additional Charges</p>
            <img
              src={Close} // Ensure Close is imported or replace with a valid image path
              onClick={() => {
                resetToInitialState();
                setAdditionalCharges(false);
              }}
              style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
            />
          </div>
        }
        closable={true}
        maskClosable={false}
        placement="right"
        closeIcon={null}
        visible={additionalCharges}
        width={400} // Increased width for a cleaner look
        onClose={() => {
          resetToInitialState();
          setAdditionalCharges(false);
        }}
      >
        {/* Service Charge */}
        <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontSize: "15px", fontWeight: 550 }}>% Service Charge</span>
          <Switch checked={serviceChargeEnabled} onChange={(checked) => setServiceChargeEnabled(checked)} style={{ marginRight: "10px" }} />
        </div>
        <div style={{ marginBottom: "20px", display: "flex", alignItems: "center" }}>
          <Select
            value={serviceChargePercentage}
            onChange={(value) => setServiceChargePercentage(value)} // Handle change
            disabled={!serviceChargeEnabled}
            style={{ width: "80px", marginRight: "10px" }}
          >
            <Option value={5}>5%</Option>
            <Option value={7}>7%</Option>
            <Option value={10}>10%</Option>
            <Option value={12}>12%</Option>
            <Option value={15}>15%</Option>
          </Select>
          <span style={{ marginLeft: "10px" }}>
            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
            {/* {serviceChargeAmount.toFixed(2)} */}
            {toFixedTruncate(serviceChargeAmount, pricePrecision)}
            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
          </span>
        </div>

        {/* Tip */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", fontSize: "15px", fontWeight: 550 }}>
            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
            Tip
            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
          </p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Select
              value={tipMode}
              onChange={(value) => {
                setTipMode(value); // Handle change for tip mode
                if (value === "Percentage") {
                  setTipPercentage(0);
                  setTipAmount(0);
                } else {
                  setTipPercentage(0);
                  setTipAmount(0);
                }
              }}
              style={{ width: 130, marginRight: "10px" }}
            >
              <Option value="Percentage">Percentage</Option>
              <Option value="Amount">Amount</Option>
            </Select>
            {tipMode === "Percentage" ? (
              <Select
                value={tipPercentage}
                onChange={(value) => setTipPercentage(value)} // Handle change for tip percentage
                style={{ width: "80px", marginRight: "10px" }}
              >
                <Option value={0}>0%</Option>
                <Option value={5}>5%</Option>
                <Option value={7}>7%</Option>
                <Option value={10}>10%</Option>
                <Option value={12}>12%</Option>
                <Option value={15}>15%</Option>
              </Select>
            ) : (
              <Input
                value={tipAmount}
                onChange={(e) => setTipAmount(parseFloat(e.target.value) || 0)} // Handle change for tip amount
                style={{ width: "100px", textAlign: "right" }}
                prefix={`${currenciesList[0].currSymbol}`}
              />
            )}
          </div>
        </div>

        {/* Delivery Charge */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <CarOutlined />
            </span>{" "}
            Delivery Charge
          </p>
          <Input
            value={deliveryCharge}
            onChange={(e) => setDeliveryCharge(parseFloat(e.target.value) || 0)} // Handle change for delivery charge
            style={{ width: "100px", textAlign: "right" }}
            prefix={`${currenciesList[0].currSymbol}`}
          />
        </div>

        {/* Packing Charge */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <GiftOutlined />
            </span>{" "}
            Packing Charge
          </p>
          <Input
            value={packingCharge}
            onChange={(e) => setPackingCharge(parseFloat(e.target.value) || 0)} // Handle change for packing charge
            style={{ width: "100px", textAlign: "right" }}
            prefix={`${currenciesList[0].currSymbol}`}
          />
        </div>

        {/* Rounding */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <ReloadOutlined />
            </span>{" "}
            Rounding
          </p>
          <Select
            value={roundingOption}
            onChange={(value) => setRoundingOption(value)} // Handle change for rounding option
            style={{ width: "150px" }}
          >
            <Option value="No Rounding">No Rounding</Option>
            <Option value="Round Up">Round Up</Option>
            <Option value="Round Down">Round Down</Option>
          </Select>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "50px" }}>
          <Button
            style={{
              backgroundColor: "#fff",
              color: "#2F3856",
              height: "40px",
              width: "100px",
              borderRadius: "5px",
              marginRight: "10px",
            }}
            onClick={() => {
              resetToInitialState();
              setAdditionalCharges(false);
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "#2F3856",
              color: "#fff",
              height: "40px",
              width: "140px",
              borderRadius: "5px",
              textAlign: "center",
            }}
            onClick={handleApplyCharges}
          >
            Apply Charges
          </Button>
        </div>
      </Drawer>

      <Modal
        centered
        visible={showSplitBill}
        closable={false}
        footer={null}
        style={{ borderRadius: "10px" }}
        bodyStyle={{ padding: "10px" }}
        // modalRender={(modal) => <div style={{ borderRadius: "10px 10px 10px 10px", overflow: "hidden", height: "66vh", width: "90%" }}>{modal}</div>}
        modalRender={(modal) => (
          <div
            style={{
              borderRadius: "10px",
              overflow: "hidden",
              height: "66vh",
              width: "90%",
            }}
          >
            {React.cloneElement(modal, {
              style: {
                ...modal.props.style,
                borderRadius: "10px",
                overflow: "hidden",
              },
            })}
          </div>
        )}
      >
        <div style={{ padding: "5px 10px 5px 10px" }}>
          <Row>
            <Col span={10} style={{ display: "flex", alignItems: "center", justifyContent: "left", color: "#0F0718", fontWeight: 500, fontSize: "1.5em", fontWeight: 600 }}>
              Current Order
            </Col>
            <Col span={14} style={{ fontSize: "1em", color: "#0F0718", fontWeight: 500, display: "flex", alignItems: "center", justifyContent: "center" }}>
              Number of Splits
              <Select
                size="small"
                defaultValue={2}
                style={{ width: 100, border: "1px solid #ccc", marginLeft: "0.5vw", borderRadius: "5px" }}
                onChange={(value) => {
                  setNumSplits(value);
                }}
              >
                {[2, 3, 4, 5, 6].map((num) => (
                  <Option key={num} value={num}>
                    {num} {"People"}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: 12 }}>
            <Col span={12}>
              <p style={{ color: "#929098", fontSize: "1em", fontWeight: 500, marginBottom: 0 }}>
                {cart?.tableNo} - {cart?.documentno}
              </p>
            </Col>
          </Row>
          <Scrollbars autoHide style={{ height: "30vh" }}>
            <Row style={{ fontSize: "1vw" }}>
              {cart?.items?.map((item, index) => (
                <React.Fragment key={index}>
                  <Col span={12} style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 400, paddingBottom: "6px" }}>
                    {item.weight}x {item?.productAliasName ? item?.productAliasName : item.name}
                  </Col>
                  <Col
                    span={12}
                    style={{
                      fontSize: "1.1em",
                      color: "#0F0718",
                      fontWeight: 400,
                      paddingBottom: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "right",
                      paddingRight: "10px",
                    }}
                  >
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {/* {item.nettotal.toFixed(item?.isQtyDesimal)} */}
                    {toFixedTruncate(item.nettotal, item?.isQtyDesimal)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                  </Col>
                </React.Fragment>
              ))}
            </Row>
          </Scrollbars>

          <Divider style={{ margin: "12px 0" }} />
          <Row>
            <Col span={12} style={{ display: "flex", alignItems: "center", justifyContent: "left", color: "#0F0718", fontSize: "1.2em", fontWeight: 500 }}>
              Total:
            </Col>
            <Col span={12} style={{ display: "flex", alignItems: "center", justifyContent: "right", color: "#0F0718", fontSize: "1.2em", fontWeight: 500 }}>
              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
              {/* {cart?.total.toFixed(2)} */}
              {toFixedTruncate(cart?.total + serviceChargeAmount + tipTotal + deliveryChargeAmount + packingChargeAmount, pricePrecision)}
              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
            </Col>
          </Row>

          <Row justify="center" gutter={16} style={{ marginTop: "1.8vh" }}>
            <Col span={12}>
              <Button
                style={{ width: "100%", border: "1px solid #92909880", borderRadius: "5px", color: "#0F0718", height: "5.5vh" }}
                onClick={() => {
                  setShowSplitBill(false);
                  setIsSplitBill(false);
                  setSplitCarts([]);
                  setCurrentSplitIndex(0);
                  setSplitBillScreen(false);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col span={12}>
              <Button
                style={{ width: "100%", border: "1px solid #92909880", borderRadius: "5px", color: "#fff", backgroundColor: "#2F3856", height: "5.5vh" }}
                type="primary"
                onClick={async () => {
                  const splitCarts = Array.from({ length: numSplits }, (_, i) => {
                    const splitItems = cart.items.map((item) => ({
                      ...item,
                      nettotal: Number(toFixedTruncate(item.nettotal / numSplits, item?.isQtyDesimal)),
                      total: Number(toFixedTruncate(item.total / numSplits, item?.isQtyDesimal)),
                      grosslist: Number(toFixedTruncate(item.grosslist / numSplits, item?.isQtyDesimal)),
                      linegross: Number(toFixedTruncate(item.linegross / numSplits, item?.isQtyDesimal)),
                      linenet: Number(toFixedTruncate(item.linenet / numSplits, item?.isQtyDesimal)),
                      sunitprice: Number(toFixedTruncate(item.sunitprice / numSplits, item?.isQtyDesimal)),
                    }));
                    return {
                      ...cart,
                      documentno: `${cart.documentno} - ${i + 1}`,
                      items: splitItems,
                      total: totalSplits[i],
                      tax: taxSplits[i],
                      subTotal: totalSplits[i] - taxSplits[i],
                      tableNo: localStorage.getItem("dineIn") === "Y" ? cart.tableNo : "",
                      splitNo: i + 1,
                      isSplit: "Y",
                    };
                  });
                  const categories = await db.productCategories.toArray();
                  const groupedItemsByCategory = categories
                    .map((cat) => {
                      const items = cart?.items?.filter((item) => item.mProductCategoryId === cat.mProductCategoryId);

                      return {
                        category: cat.name,
                        categoryId: cat.mProductCategoryId,
                        items,
                      };
                    })
                    .filter((group) => group.items.length > 0);
                  setGroupedItems(groupedItemsByCategory);
                  setSplitCarts(splitCarts);
                  setIsSplitBill(true);
                  setCurrentSplitIndex(0);
                  // setCart(splitCarts[0]);
                  setSplitBillScreen(true);
                  setShowSplitBill(false);
                  setShowAllItems(true);
                }}
              >
                Split Bill
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>

      <Modal
        title="Copy KOT"
        visible={copyKOTVisible}
        onCancel={() => setCopyKOTVisible(false)}
        footer={null}
        width={520}
        bodyStyle={{
          height: "60vh", // 🔥 FIXED HEIGHT
          display: "flex",
          flexDirection: "column",
          paddingBottom: 0,
        }}
      >
        <p style={{ marginTop: -5, color: "#6B7280" }}>Select items to copy and fire again</p>
        <div
          style={{
            flex: 1,
            overflowY: "auto", // 🔥 ENABLE SCROLL
            paddingRight: 6,
            marginBottom: 20,
          }}
        >
          {Object.keys(groupedFiredItems).map((cat) => (
            <div key={cat} style={{ marginBottom: 20 }}>
              <p style={{ fontWeight: 600 }}>— {cat} —</p>

              {groupedFiredItems[cat].map((item) => {
                // ✔ Use productId instead of lineId
                const isSelected = selectedCopyItems[item.productId] !== undefined;
                const qty = selectedCopyItems[item.productId] || 1;

                return (
                  <div
                    key={item.productId} // ✔ key by productId
                    style={{
                      background: isSelected ? "#EEF2FF" : "#F8FAFC",
                      border: "1px solid #E5E7EB",
                      padding: "10px 14px",
                      borderRadius: 8,
                      marginBottom: 8,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      checked={isSelected}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedCopyItems((prev) => ({
                            ...prev,
                            [item.productId]: 1, // default qty = 1
                          }));
                        } else {
                          setSelectedCopyItems((prev) => {
                            const updated = { ...prev };
                            delete updated[item.productId];
                            return updated;
                          });
                        }
                      }}
                    >
                      {item?.productAliasName ? item?.productAliasName : item.name}

                      <span
                        style={{
                          background: "#22C55E",
                          color: "#fff",
                          padding: "2px 10px",
                          borderRadius: 6,
                          fontSize: "0.75rem",
                          marginLeft: 10,
                        }}
                      >
                        Fired
                      </span>
                    </Checkbox>
                    {isSelected && (
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <Button
                          size="small"
                          onClick={() => {
                            if (qty > 1) {
                              setSelectedCopyItems((prev) => ({
                                ...prev,
                                [item.productId]: qty - 1,
                              }));
                            }
                          }}
                          style={{ width: 32 }}
                        >
                          −
                        </Button>

                        <span>{qty}</span>

                        <Button
                          size="small"
                          onClick={() => {
                            setSelectedCopyItems((prev) => ({
                              ...prev,
                              [item.productId]: qty + 1,
                            }));
                          }}
                          style={{ width: 32 }}
                        >
                          +
                        </Button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        {/* FOOTER BUTTONS */}
        <div style={{ textAlign: "right", marginBottom: 15 }}>
          <Button onClick={() => setCopyKOTVisible(false)}>Cancel</Button>

          <Button type="primary" icon={<CopyOutlined />} style={{ marginLeft: 10 }} disabled={Object.keys(selectedCopyItems).length === 0} onClick={handleCopyKOTConfirm}>
            Copy & Fire
          </Button>
        </div>
      </Modal>

      <Modal visible={cancelKotItems} onCancel={() => setCancelKotItems(false)} footer={null} width={450} centered>
        <div style={{ fontSize: 18, fontWeight: 600 }}>Cancel Order Items</div>

        <div style={{ fontSize: 13, color: "#777", marginBottom: 16 }}>Select items you want to cancel. Items are grouped by KOT token.</div>

        {/* SELECT ALL */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <Checkbox checked={cart?.items?.length > 0 && selectedItemIds.length === cart.items.length} onChange={(e) => toggleAll(e.target.checked)}>
            Select All Items
          </Checkbox>

          <span style={{ fontSize: 12, color: "#888" }}>
            {selectedItemIds.length} of {cart?.items?.length || 0} selected
          </span>
        </div>

        {/* LIST */}
        <div style={{ maxHeight: 220, overflowY: "auto" }}>
          {/* {Object.entries(groupedKotItems).map(([kotId, items], index) => { */}
          {Object.entries(groupedKotItems)
            .map(([kotId, items]) => {
              const activeItems = items.filter((item) => item.isCanceled !== "Y");
              if (activeItems.length === 0) return null;
              return [kotId, activeItems];
            })
            .filter(Boolean)
            .map(([kotId, items], index) => {
              let cancellableItems = items.filter((item) => item.orderStatus === "OR" || item.orderStatus === "IP");

              let isKotCancellable = cancellableItems.length > 0;

              // const allKotSelected = items.every((i) => selectedItemIds.includes(i.lineId));
              const allKotSelected = isKotCancellable && cancellableItems.every((i) => selectedItemIds.includes(i.fbOrderLineId));

              return (
                <div
                  key={kotId}
                  style={{
                    border: "1px solid #e5e5e5",
                    borderRadius: 8,
                    padding: 10,
                    marginBottom: 12,
                    opacity: isKotCancellable ? 1 : 0.45,
                  }}
                >
                  {/* KOT HEADER */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      marginBottom: 8,
                    }}
                  >
                    <Checkbox
                      checked={allKotSelected}
                      disabled={!isKotCancellable}
                      onChange={(e) => {
                        if (!isKotCancellable) return;
                        toggleKot(cancellableItems, e.target.checked);
                      }}
                    />
                    <b>KOT #{index + 1}</b>
                    <span style={{ fontSize: 12, color: "#888" }}>{items.length} items</span>
                  </div>

                  {/* ITEMS */}
                  {items.map((item) => {
                    const isCancellable = item.orderStatus === "OR" || item.orderStatus === "IP";
                    return (
                      <div
                        key={item.lineId}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                          padding: "8px 0",
                          borderTop: "1px solid #f0f0f0",
                          opacity: isCancellable ? 1 : 0.45,
                          pointerEvents: isCancellable ? "auto" : "none",
                          cursor: isCancellable ? "default" : "not-allowed",
                        }}
                      >
                        <Checkbox
                          checked={selectedItemIds.includes(item.fbOrderLineId)}
                          disabled={!isCancellable}
                          onChange={() => {
                            if (!isCancellable) return;
                            toggleItem(item.fbOrderLineId);
                          }}
                        />

                        <div style={{ flex: 1 }}>
                          <div>{item?.productAliasName ? item?.productAliasName : item.name}</div>
                          <div style={{ fontSize: 12, color: "#888" }}>Qty: {item.weight}</div>
                        </div>

                        <div style={{ width: 90, textAlign: "right" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {Number(item.linegross || item.nettotal).toFixed(2)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                        </div>

                        <Tag
                          color={
                            item.orderStatus === "OR"
                              ? "blue"
                              : item.orderStatus === "IP"
                                ? "orange"
                                : item.orderStatus === "RC"
                                  ? "green"
                                  : item.orderStatus === "CO"
                                    ? "purple"
                                    : item.orderStatus === "CL"
                                      ? "red"
                                      : "default"
                          }
                          style={{ borderRadius: "4px", padding: "1px 3px 1px 3px" }}
                        >
                          {item.orderStatus === "OR"
                            ? "Order Received"
                            : item.orderStatus === "IP"
                              ? "In Progress"
                              : item.orderStatus === "RC"
                                ? "Ready to Collect"
                                : item.orderStatus === "CO"
                                  ? "Completed"
                                  : item.orderStatus === "CL"
                                    ? "Cancelled"
                                    : ""}
                        </Tag>
                      </div>
                    );
                  })}
                </div>
              );
            })}
        </div>

        {/* FOOTER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 20,
          }}
        >
          <Button onClick={() => setCancelKotItems(false)}>Close</Button>

          <div style={{ display: "flex", gap: 10 }}>
            <Button
              disabled={!selectedItemIds.length}
              onClick={() => {
                setCancelKotItems(false);
                handleVoid(selectedTable, selectedItemIds);
                CWKOTPrinter(filteredCartObj, false, true);
              }}
            >
              Cancel Selected ({selectedItemIds.length})
            </Button>
            <Button
              type="primary"
              style={{ background: "#2F3856" }}
              // onClick={async () => {
              //   if (cart?.items?.some((item) => item.orderStatus === "OR" || item.orderStatus === "IP")) {
              //     const cancellableIds = Object.values(groupedKotItems)
              //       .flat()
              //       .filter((item) => item.isCanceled !== "Y" && (item.orderStatus === "OR" || item.orderStatus === "IP"))
              //       .map((item) => item.lineId);

              //     await handleVoid(selectedTable, "ALL");
              //     setCancelKotItems(false);
              //   }
              // }}
              onClick={async () => {
                const cancellableItemIds = cart?.items?.filter((item) => !["RC", "CO", "CL"].includes(item.orderStatus)).map((item) => item.fbOrderLineId);
                if (!cancellableItemIds.length) {
                  console.warn("⚠️ No cancellable items found. Cancel aborted.");
                  return;
                }

                await handleVoid(selectedTable, cancellableItemIds);
                setCancelKotItems(false);
              }}
            >
              Cancel All
            </Button>
          </div>
        </div>
      </Modal>

      {showProdCenterModal && prodItem && (
        <Modal
          visible={showProdCenterModal}
          onCancel={() => setShowProdCenterModal(false)}
          footer={null}
          centered
          closable={true}
          maskClosable={true}
          width={420}
          bodyStyle={{
            padding: "20px",
            background: "#ffffff",
            height: "380px",
          }}
          className="production-center-modal" // ← only this one class
          title={
            <span
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                maxWidth: "320px",
              }}
              title={prodItem.name}
            >
              Production Centre for {prodItem.name}
            </span>
          }
        >
          <div
            style={{
              height: "100%",
              overflowY: "scroll",
              paddingRight: "4px",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
              }}
            >
              {productionCentersOptions.map((pc) => (
                <div
                  key={pc.value}
                  onClick={() => {
                    const updatedItems = cart.items.map((i) => (i.lineId === prodItem.lineId ? { ...i, productionCenterId: pc.value, productionCenter: pc.label } : i));
                    setCart({ ...cart, items: updatedItems });
                    setShowProdCenterModal(false);
                  }}
                  style={{
                    border: prodItem.productionCenterId === pc.value ? "2px solid #f3f4f9" : "1px solid #d9d9d9",
                    background: prodItem.productionCenterId === pc.value ? "#9fa4ae" : "#ffffff",
                    padding: "16px 0",
                    borderRadius: "12px",
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: "1rem",
                    fontWeight: 500,
                    color: "#0F0718",
                    transition: "all 0.2s",
                  }}
                >
                  {pc.label}
                </div>
              ))}
            </div>
          </div>
        </Modal>
      )}

      <Modal
        visible={saleTypeModalOpen}
        onCancel={() => setSaleTypeModalOpen(false)}
        footer={null}
        centered
        closable={true}
        maskClosable={true}
        width={420}
        bodyStyle={{
          height: "380px",
          padding: "20px",
          background: "#ffffff",
        }}
        className="production-center-modal"
        title={
          <div
            style={{
              fontSize: "1.25rem",
              fontWeight: 600,
              color: "#0F0718",
              marginBottom: "16px",
            }}
          >
            Order Type
          </div>
        }
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
          }}
        >
          <div
            onClick={() => {
              const updatedItems = cart.items.map((i) => (i.lineId === saleTypeModalItem.lineId ? { ...i, saleType: "DI" } : i));
              setCart({ ...cart, items: updatedItems });
              setSaleTypeModalOpen(false);
            }}
            style={{
              border: saleTypeModalItem?.saleType === "DI" ? "2px solid #f3f4f9" : "1px solid #d9d9d9",
              background: saleTypeModalItem?.saleType === "DI" ? "#9fa4ae" : "#ffffff",
              padding: "16px 0",
              borderRadius: "12px",
              textAlign: "center",
              fontSize: "1rem",
              fontWeight: 500,
              color: "#0F0718",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            Dine In
          </div>

          <div
            onClick={() => {
              const updatedItems = cart.items.map((i) => (i.lineId === saleTypeModalItem.lineId ? { ...i, saleType: "TA" } : i));
              setCart({ ...cart, items: updatedItems });
              setSaleTypeModalOpen(false);
            }}
            style={{
              border: saleTypeModalItem?.saleType === "TA" ? "2px solid #f3f4f9" : "1px solid #d9d9d9",
              background: saleTypeModalItem?.saleType === "TA" ? "#9fa4ae" : "#ffffff",
              padding: "16px 0",
              borderRadius: "12px",
              textAlign: "center",
              fontSize: "1rem",
              fontWeight: 500,
              color: "#0F0718",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            Take Away
          </div>
        </div>
      </Modal>

      <Drawer
        title={null}
        placement="right"
        visible={parkedDrawerOpen}
        onClose={() => setParkedDrawerOpen(false)}
        width="29%"
        bodyStyle={{
          padding: "24px",
          background: "#F7F8FC",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
        headerStyle={{ display: "none" }}
      >
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: "#2F3856",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 12,
            }}
          >
            <CodeSandboxOutlined style={{ fontSize: 20, color: "white" }} />
          </div>

          <div style={{ flexGrow: 1 }}>
            <div style={{ fontSize: "1.2rem", fontWeight: 600, color: "#0F0718" }}>Parked Orders</div>
            <div style={{ fontSize: "0.85rem", color: "#9197A3" }}>{storedParkedList?.length} order(s) on hold</div>
          </div>

          <CloseOutlined style={{ fontSize: 18, cursor: "pointer" }} onClick={() => setParkedDrawerOpen(false)} />
        </div>

        {/* Scrollable card container */}
        <div
          style={{
            overflowY: "auto",
            paddingRight: "8px",
            flexGrow: 1,
          }}
        >
          {storedParkedList.length === 0 ? (
            <div style={{ textAlign: "center", color: "#9CA3AF", marginTop: "40px" }}>No parked orders</div>
          ) : (
            storedParkedList.map((order, index) => {
              const cart = order.parkedCart || {};
              const items = cart.items || [];
              return (
                <ParkedOrderCard
                  orderData={order}
                  key={order.parkedBillId}
                  orderId={order.parkedDocNo}
                  name={cart.customer?.name || ""}
                  // time={formatParkedTime(order.parkedTime)}
                  items={items.length}
                  total={cart.total}
                  productList={items.map((item) => ({
                    label: `${item.weight}x ${item?.productAliasName ? item?.productAliasName : item.name}`,
                    price: item.nettotal,
                  }))}
                />
              );
            })
          )}
        </div>
      </Drawer>

      {seatGuestDrawerOpen && <TableFeatures {...props} />}
      {showReprintKotDialog && (
        <ReprintKotDialog
          isOpen={showReprintKotDialog}
          onClose={() => setShowReprintKotDialog(false)}
          groupedProducts={{
            ...cart,
            items: cartItems,
          }}
        />
      )}
    </>
  );
};

export default MenuLayout;
